/* 我的练习页（/my/）专属脚本：从 app.js 拆出，仅 /my/ 页由 layout.ts 以 defer 加载且排在 app.js 之前。
   app.js 在原调用位置以闭包内共享工具实例化本工厂，并按原顺序调用返回的 4 个 init（行为与拆分前等价）。
   与 app.js 同约定：ES2017、无模块、CSP 无内联。 */
window.__tikuMy = function (c) {
  var store = c.store, localDay = c.localDay, toSlug = c.toSlug, shuffleSlugs = c.shuffleSlugs, QTYPE = c.QTYPE, wrongDue = c.wrongDue, readNotes = c.readNotes, WEAK_MIN_DONE = c.WEAK_MIN_DONE, WEAK_ACC = c.WEAK_ACC, stars = c.stars, bindNote = c.bindNote, saveNote = c.saveNote, smartPracticeHref = c.smartPracticeHref, weeklyMockDone = c.weeklyMockDone, dailyDoneToday = c.dailyDoneToday, planQuotaHref = c.planQuotaHref, planMoreHref = c.planMoreHref, curWeekIso = c.curWeekIso, showNavChip = c.showNavChip, NOTE_KEY = c.NOTE_KEY, capNotes = c.capNotes, FBK_LABEL = c.FBK_LABEL;

  /* 初始化时发起的列表异步填充（错题/收藏/笔记/掌握度）；锚点直达要等这批回来再显示，避免锚点下方内容后插 */
  var firstFills = [];
  function trackFill(p) { firstFills.push(p.then(null, function () { /* noop */ })); return p; }
  function fillsSettled() { return Promise.all(firstFills); }
  /* ---------- 我的练习（/my/） ---------- */
  function initMy() {
    var doneStat = document.getElementById('stat-done'); if (!doneStat) return;
    var done = store.readList('tiku-done').map(toSlug).filter(Boolean);
    var wrong = store.readList('tiku-wrong').map(toSlug).filter(Boolean);
    var favs = store.readList('tiku-fav').map(toSlug).filter(Boolean);
    doneStat.textContent = String(done.length);
    document.getElementById('stat-fav').textContent = String(favs.length);
    var st = store.read('tiku-stats', '{"a":0,"c":0}');
    /* 练习时长：tiku-mins 逐日秒数求和（交卷时落账，与报告用时同口径）与全时计数器 tiku-stats.u 取大：tiku-mins 只留 126 天 */
    var timeStat = document.getElementById('stat-time');
    if (timeStat) {
      var mins = store.read('tiku-mins', '{}');
      var totalSec = 0;
      Object.keys(mins).forEach(function (k) { if (typeof mins[k] === 'number' && mins[k] > 0) totalSec += mins[k]; });
      totalSec = Math.max(totalSec, typeof st.u === 'number' ? st.u : 0);
      var totalMin = Math.round(totalSec / 60);
      if (totalMin > 0) { timeStat.textContent = totalMin >= 60 ? Math.floor(totalMin / 60) + ' 时 ' + (totalMin % 60) + ' 分' : totalMin + ' 分'; }
    }
    if (st.a > 0) {
      var acc = Math.max(0, Math.min(100, Math.round(st.c / st.a * 100)));
      document.getElementById('stat-acc').textContent = acc + '%';
      /* 正确率环形 + 近 7 日做题条形 */
      var charts = document.getElementById('my-charts');
      if (charts) {
        charts.classList.remove('hidden'); charts.classList.add('grid');
        var ring = document.getElementById('my-ring');
        var CIRC = 2 * Math.PI * 52;
        if (ring) requestAnimationFrame(function () { ring.setAttribute('stroke-dasharray', (CIRC * acc / 100) + ' ' + CIRC); });
        var pctEl = document.getElementById('my-ring-pct'); if (pctEl) pctEl.textContent = acc + '%';
        var chart = document.getElementById('days-chart');
        if (chart) {
          var days = store.read('tiku-days', '{}');
          var max = 1; var series = [];
          for (var di = 6; di >= 0; di--) {
            var dd = new Date(); dd.setDate(dd.getDate() - di);
            var k = localDay(dd); var v = days[k] || 0;
            if (v > max) max = v;
            series.push({ label: k.slice(5).replace('-', '/'), n: v });
          }
          series.forEach(function (it) {
            var col = document.createElement('div');
            col.className = 'flex h-full flex-1 flex-col items-center justify-end gap-1';
            var bar = document.createElement('div');
            bar.className = 'w-full max-w-8 rounded-t ' + (it.n > 0 ? 'bg-brand-600' : 'bg-slate-100');
            bar.style.height = Math.max(it.n / max * 100, it.n > 0 ? 8 : 4) + '%';
            bar.title = it.n + ' 题';
            var lb = document.createElement('span'); lb.className = 'text-[10px] text-muted'; lb.textContent = it.label;
            col.appendChild(bar); col.appendChild(lb); chart.appendChild(col);
          });
        }
        renderHeatmap();
      }
    } else {
      var noCharts = document.getElementById('my-charts'); if (noCharts) noCharts.hidden = true;
      var noHeat = document.getElementById('heatmap-card'); if (noHeat) noHeat.hidden = true;
    }
    renderTrend();
    renderWeekly();
    renderAchievements();
    /* 成就勋章：本地数据实时计算六系列三档里程碑；累计类取「窗口内求和 vs tiku-stats 全时计数器」两者之大（tiku-days 126 天 / tiku-hist 50 条上限不能让全时成就回落） */
    function renderAchievements() {
      var card = document.getElementById('ach-card');
      var grid = document.getElementById('ach-grid');
      if (!card || !grid || grid.dataset.filled) return;
      grid.dataset.filled = '1';
      var stA = store.read('tiku-stats', '{"a":0,"c":0}');
      function allTime(k) { return typeof stA[k] === 'number' && stA[k] > 0 ? stA[k] : 0; }
      var days = store.read('tiku-days', '{}');
      var totalQ = 0;
      Object.keys(days).forEach(function (k) { var v = days[k]; if (typeof v === 'number' && v > 0) totalQ += v; });
      totalQ = Math.max(totalQ, allTime('a'));
      var streak = 0;
      var sd = new Date();
      if (!days[localDay(sd)]) { sd.setDate(sd.getDate() - 1); }
      while (days[localDay(sd)]) { streak++; sd.setDate(sd.getDate() - 1); }
      var hist = store.read('tiku-hist', '[]');
      if (!Array.isArray(hist)) hist = [];
      var sessions = 0; var perfect = 0;
      hist.forEach(function (h) {
        if (!h || !(h.n > 0)) return;
        sessions++;
        if (h.ok === h.n && h.n >= 5) perfect++;
      });
      var series = [
        { name: '累计刷题', v: totalQ, tiers: [100, 500, 2000], unit: '题' },
        { name: '连续打卡', v: streak, tiers: [3, 7, 30], unit: '天' },
        { name: '练习场次', v: Math.max(sessions, allTime('p')), tiers: [10, 50, 200], unit: '次' },
        { name: '满分卷', v: Math.max(perfect, allTime('f')), tiers: [1, 5, 20], unit: '卷' },
        { name: '错题出师', v: store.read('tiku-wrongg', '0') || 0, tiers: [1, 10, 50], unit: '题' },
        { name: '连对达人', v: store.read('tiku-combo', '0') || 0, tiers: [5, 10, 20], unit: '题' }
      ];
      if (!series.some(function (s) { return s.v > 0; })) { card.hidden = true; return; }
      var MEDALS = ['🥉', '🥈', '🥇'];
      grid.textContent = '';
      series.forEach(function (s) {
        var lvl = -1;
        for (var ti = 0; ti < s.tiers.length; ti++) { if (s.v >= s.tiers[ti]) lvl = ti; }
        var cell = document.createElement('div');
        cell.className = 'rounded-xl p-3 ' + (lvl >= 0 ? 'bg-amber-50' : 'bg-slate-50');
        var head = document.createElement('p'); head.className = 'flex items-center gap-1.5 text-[12px] text-muted';
        var medal = document.createElement('span'); medal.className = 'text-base' + (lvl >= 0 ? '' : ' opacity-40 grayscale');
        medal.textContent = lvl >= 0 ? MEDALS[lvl] : '🔒';
        head.appendChild(medal);
        var nm = document.createElement('span'); nm.textContent = s.name; head.appendChild(nm);
        var val = document.createElement('p'); val.className = 'mt-1 text-lg font-semibold tabular-nums';
        val.textContent = s.v + ' ' + s.unit;
        var sub = document.createElement('p'); sub.className = 'mt-0.5 text-[12px] tabular-nums text-muted';
        if (lvl >= s.tiers.length - 1) { sub.className = 'mt-0.5 text-[12px] font-medium text-amber-700'; sub.textContent = '已达最高档'; }
        else { var next = s.tiers[lvl + 1]; sub.textContent = '差 ' + (next - s.v) + ' ' + s.unit + ' 升 ' + MEDALS[lvl + 1]; }
        cell.appendChild(head); cell.appendChild(val); cell.appendChild(sub);
        grid.appendChild(cell);
      });
      card.classList.remove('hidden');
      showNavChip('ach-card');
    }
    /* 学习周报：本周 vs 上周（周一起算）。作答题数 / 总用时按 tiku-days / tiku-mins 全来源（题页 + 操作台）按日聚合；
       正确率 = 有 tiku-dayok 记录的日子 Σdayok / Σdays（全来源；未记录日不进分母），窗口内无记录日时回退 tiku-hist 卷口径；练习次数取 tiku-hist 卷数 */
    function renderWeekly() {
      var card = document.getElementById('weekly-card');
      var grid = document.getElementById('weekly-grid');
      var minsBox = document.getElementById('weekly-mins');
      if (!card || !grid || grid.dataset.filled) return;
      grid.dataset.filled = '1';
      var hist = store.read('tiku-hist', '[]');
      if (!Array.isArray(hist)) hist = [];
      var dayN = store.read('tiku-days', '{}');
      var daySec = store.read('tiku-mins', '{}');
      var dayOk = store.read('tiku-dayok', '{}');
      var start = new Date(); start.setHours(0, 0, 0, 0);
      start.setDate(start.getDate() - (start.getDay() + 6) % 7);
      var prev = start.getTime() - 7 * 864e5;
      function agg(from, to) {
        var a = { p: 0, hn: 0, ok: 0, n: 0, u: 0, tn: 0, tok: 0 };
        hist.forEach(function (h) {
          if (!h || !h.d || !(h.n > 0)) return;
          var t = h.d * 1000;
          if (t >= from && t < to) { a.p++; a.hn += h.n - (h.un > 0 ? h.un : 0); a.ok += h.ok || 0; }
        });
        for (var i = 0; i < 7; i++) {
          var k = localDay(new Date(from + i * 864e5));
          if (typeof dayN[k] === 'number' && dayN[k] > 0) a.n += dayN[k];
          if (typeof daySec[k] === 'number' && daySec[k] > 0) a.u += daySec[k];
          if (typeof dayOk[k] === 'number' && dayOk[k] >= 0 && dayN[k] > 0) { a.tn += dayN[k]; a.tok += Math.min(dayOk[k], dayN[k]); }
        }
        return a;
      }
      /* 正确率（百分数）：全来源已记录日优先，否则卷口径，都无为 null */
      function accOf(a) {
        if (a.tn > 0) return Math.round(a.tok / a.tn * 100);
        if (a.hn > 0) return Math.round(a.ok / a.hn * 100);
        return null;
      }
      var cur = agg(start.getTime(), start.getTime() + 7 * 864e5);
      var last = agg(prev, start.getTime());
      var lastAny = last.p > 0 || last.n > 0 || last.u > 0;
      if (!(cur.p > 0 || cur.n > 0 || cur.u > 0) && !lastAny) { card.hidden = true; return; }
      grid.textContent = '';
      function fmtU(sec) {
        var m = Math.round(sec / 60);
        return m >= 60 ? Math.floor(m / 60) + ' 时 ' + (m % 60) + ' 分' : m + ' 分';
      }
      var accCur = accOf(cur);
      var accLast = accOf(last);
      var items = [
        { label: '作答题数', v: String(cur.n), c: cur.n, l: last.n, unit: ' 题' },
        { label: '正确率', v: accCur === null ? '—' : accCur + '%', c: accCur || 0, l: accLast || 0, unit: '%', na: accCur === null || accLast === null || (cur.tn > 0) !== (last.tn > 0),
          note: accCur === null ? (cur.n > 0 ? '暂无正确率记录' : '') : (cur.tn > 0 ? '' : '仅统计练习卷') },
        { label: '练习次数', v: String(cur.p), c: cur.p, l: last.p, unit: ' 次' },
        { label: '总用时', v: fmtU(cur.u), c: Math.round(cur.u / 60), l: Math.round(last.u / 60), unit: ' 分' }
      ];
      items.forEach(function (it) {
        var cell = document.createElement('div');
        cell.className = 'rounded-xl bg-slate-50 p-3';
        var lb = document.createElement('p'); lb.className = 'text-[12px] text-muted'; lb.textContent = it.label;
        var val = document.createElement('p'); val.className = 'mt-1 text-lg font-semibold tabular-nums'; val.textContent = it.v;
        var d = document.createElement('p'); d.className = 'mt-0.5 text-[12px] tabular-nums';
        if (it.note) { d.className += ' text-muted'; d.textContent = it.note; }
        else if (!lastAny) { d.className += ' font-medium text-brand-700'; d.textContent = '新'; }
        else if (it.na) { d.className += ' text-muted'; d.textContent = '—'; }
        else {
          var diff = it.c - it.l;
          if (diff > 0) { d.className += ' font-medium text-emerald-700'; d.textContent = '↑ 较上周 +' + diff + it.unit; }
          else if (diff < 0) { d.className += ' font-medium text-rose-700'; d.textContent = '↓ 较上周 −' + (-diff) + it.unit; }
          else { d.className += ' text-muted'; d.textContent = '与上周持平'; }
        }
        cell.appendChild(lb); cell.appendChild(val); cell.appendChild(d); grid.appendChild(cell);
      });
      /* 近 7 天每日练习时长柱状图（tiku-mins，全 0 不渲染） */
      (function () {
        var mins = store.read('tiku-mins', '{}');
        var days = [];
        var maxMin = 0;
        var today = new Date(); today.setHours(0, 0, 0, 0);
        for (var i = 6; i >= 0; i--) {
          var d0 = new Date(today.getTime() - i * 864e5);
          var m0 = Math.round(((mins[localDay(d0)] || 0)) / 60);
          if (m0 > maxMin) maxMin = m0;
          days.push({ m: m0, wd: '日一二三四五六'.charAt(d0.getDay()), today: i === 0 });
        }
        if (!maxMin) { if (minsBox) minsBox.hidden = true; return; }
        /* SSR 骨架 #weekly-mins（7 列，柱容器 h-16 定高）已定几何，这里只填数值与柱高 */
        var cols = minsBox ? Array.prototype.slice.call(minsBox.querySelectorAll('.flex-col')) : [];
        if (cols.length !== days.length) return;
        days.forEach(function (dy, i) {
          var col = cols[i];
          var num = col.children[0]; var bar = col.children[1] && col.children[1].firstElementChild; var lb2 = col.children[2];
          if (!num || !bar || !lb2) return;
          num.className = 'text-[11px] tabular-nums ' + (dy.m > 0 ? 'font-medium text-ink' : 'text-transparent');
          num.textContent = dy.m > 0 ? String(dy.m) : '0';
          var h = dy.m > 0 ? Math.max(4, Math.round(dy.m / maxMin * 64)) : 2;
          bar.className = 'w-full rounded-t ' + (dy.m > 0 ? (dy.today ? 'bg-brand-600' : 'bg-brand-600/45') : 'bg-slate-100');
          bar.style.height = h + 'px';
          bar.setAttribute('aria-label', '练习 ' + dy.m + ' 分钟');
          lb2.className = 'text-[11px] ' + (dy.today ? 'font-semibold text-brand-700' : 'text-muted');
          lb2.textContent = dy.today ? '今' : dy.wd;
        });
        minsBox.hidden = false;
        minsBox.classList.remove('hidden');
      })();
      initWeeklyShare(cur, accCur, fmtU, start);
      card.classList.remove('hidden');
    }
    /* 分享周报：纯客户端 Canvas 生成 PNG，仅含本地聚合数字，不上传任何数据 */
    function initWeeklyShare(cur, accCur, fmtU, weekStart) {
      var btn = document.getElementById('weekly-share');
      var msg = document.getElementById('weekly-share-msg');
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      function say(t) { if (msg) { msg.textContent = t; msg.classList.remove('hidden'); } }
      if (!window.qrcode && !document.getElementById('wk-qrlib')) {
        var s = document.createElement('script');
        s.id = 'wk-qrlib'; s.src = '/qrcode.js?v=1'; s.async = true;
        document.head.appendChild(s);
      }
      function drawQR(ctx, cx, top) {
        if (!window.qrcode) return false;
        try {
          var q = window.qrcode(0, 'M');
          q.addData('https://tiku.zalize.com/'); q.make();
          var n = q.getModuleCount();
          var size = 130; var cell = size / n; var x0 = cx - size / 2;
          ctx.fillStyle = '#ffffff'; ctx.fillRect(x0 - 12, top - 12, size + 24, size + 24);
          ctx.fillStyle = '#0f172a';
          for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) {
            if (q.isDark(r, c)) ctx.fillRect(x0 + c * cell, top + r * cell, Math.ceil(cell), Math.ceil(cell));
          }
          return true;
        } catch (_) { return false; }
      }
      function drawCard() {
        var W = 750; var H = 1140;
        var cv = document.createElement('canvas');
        cv.width = W; cv.height = H;
        var ctx = cv.getContext('2d');
        ctx.fillStyle = '#f0fdfa'; ctx.fillRect(0, 0, W, H);
        ctx.fillStyle = '#0d9488'; ctx.fillRect(0, 0, W, 148);
        ctx.fillStyle = '#ffffff'; ctx.textAlign = 'left';
        ctx.font = 'bold 44px system-ui, sans-serif';
        ctx.fillText('刷题营', 48, 78);
        ctx.font = '26px system-ui, sans-serif'; ctx.globalAlpha = 0.85;
        var we = new Date(weekStart.getTime() + 6 * 864e5);
        function md(d) { return (d.getMonth() + 1) + '/' + d.getDate(); }
        ctx.fillText('学习周报 · ' + md(weekStart) + '–' + md(we), 48, 118);
        ctx.globalAlpha = 1;
        var days = store.read('tiku-days', '{}');
        var streak = 0; var sd = new Date();
        if (!days[localDay(sd)]) sd.setDate(sd.getDate() - 1);
        while (days[localDay(sd)]) { streak++; sd.setDate(sd.getDate() - 1); }
        if (streak >= 2) {
          ctx.textAlign = 'right'; ctx.font = 'bold 28px system-ui, sans-serif';
          ctx.fillText('🔥 连续打卡 ' + streak + ' 天', W - 48, 118);
          ctx.textAlign = 'left';
        }
        /* 四格核心数据（与页内周报同口径：题数 / 用时全来源，正确率仅练习卷） */
        var items = [
          [String(cur.n), '作答题数'],
          [accCur === null ? '—' : accCur + '%', '正确率'],
          [String(cur.p), '练习次数'],
          [fmtU(cur.u), '总用时']
        ];
        ctx.textAlign = 'center';
        items.forEach(function (it, i) {
          var x = W / 8 + i * (W / 4);
          ctx.fillStyle = '#0f172a'; ctx.font = 'bold 46px system-ui, sans-serif';
          ctx.fillText(it[0], x, 268);
          ctx.fillStyle = '#64748b'; ctx.font = '26px system-ui, sans-serif';
          ctx.fillText(it[1], x, 314);
        });
        /* 近 7 天练习时长柱状图（tiku-mins，与页内 R314 同数据） */
        var mins = store.read('tiku-mins', '{}');
        var bars = []; var maxMin = 0;
        var today = new Date(); today.setHours(0, 0, 0, 0);
        for (var i = 6; i >= 0; i--) {
          var d0 = new Date(today.getTime() - i * 864e5);
          var m0 = Math.round((mins[localDay(d0)] || 0) / 60);
          if (m0 > maxMin) maxMin = m0;
          bars.push({ m: m0, wd: i === 0 ? '今' : '日一二三四五六'.charAt(d0.getDay()) });
        }
        ctx.fillStyle = '#64748b'; ctx.font = '26px system-ui, sans-serif';
        ctx.fillText('近 7 天练习时长（分钟）', W / 2, 396);
        var chartTop = 430; var chartH = 200; var baseY = chartTop + chartH;
        var colW = (W - 96) / 7;
        bars.forEach(function (b, i) {
          var cx0 = 48 + i * colW + colW / 2;
          var h = b.m > 0 && maxMin > 0 ? Math.max(8, Math.round(b.m / maxMin * chartH)) : 4;
          ctx.fillStyle = b.m > 0 ? (i === 6 ? '#0d9488' : 'rgba(13,148,136,.45)') : '#e2e8f0';
          ctx.fillRect(cx0 - 26, baseY - h, 52, h);
          if (b.m > 0) {
            ctx.fillStyle = '#0f172a'; ctx.font = 'bold 24px system-ui, sans-serif';
            ctx.fillText(String(b.m), cx0, baseY - h - 12);
          }
          ctx.fillStyle = i === 6 ? '#0d9488' : '#64748b'; ctx.font = '24px system-ui, sans-serif';
          ctx.fillText(b.wd, cx0, baseY + 36);
        });
        var hasQR = drawQR(ctx, W / 2, 762);
        if (hasQR) {
          ctx.fillStyle = '#64748b'; ctx.font = '24px system-ui, sans-serif';
          ctx.fillText('扫码一起来刷题', W / 2, 938);
        }
        var d = new Date();
        ctx.fillStyle = '#94a3b8'; ctx.font = '26px system-ui, sans-serif';
        ctx.fillText(d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate() + ' · 一起来刷题 tiku.zalize.com', W / 2, 1088);
        return cv;
      }
      btn.addEventListener('click', function () {
        drawCard().toBlob(function (blob) {
          if (!blob) { say('生成图片失败，请稍后再试'); return; }
          var file = null;
          try { file = new File([blob], 'tiku-weekly.png', { type: 'image/png' }); } catch (_) { /* noop */ }
          if (file && navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator.share({ files: [file], title: '刷题营学习周报' }).catch(function () { /* 用户取消 */ });
            return;
          }
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'tiku-weekly.png';
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(function () { URL.revokeObjectURL(a.href); }, 5000);
          say('周报卡已保存为图片（tiku-weekly.png）');
        }, 'image/png');
      });
    }
    /* 正确率趋势点位：全来源按学习日（tiku-dayok / tiku-days 已记录日，与周报 agg() 同判定）最近 10 日优先；
       已记录日 < 2 时回退 tiku-hist 近 10 次练习（过渡期老用户） */
    function trendPoints() {
      var dayN = store.read('tiku-days', '{}');
      var dayOk = store.read('tiku-dayok', '{}');
      var keys = [];
      if (dayOk && typeof dayOk === 'object' && dayN && typeof dayN === 'object') {
        for (var k in dayOk) {
          if (/^\d{4}-\d{2}-\d{2}$/.test(k) && typeof dayOk[k] === 'number' && dayOk[k] >= 0 && typeof dayN[k] === 'number' && dayN[k] > 0) keys.push(k);
        }
      }
      keys.sort();
      if (keys.length >= 2) {
        return { mode: 'day', pts: keys.slice(-10).map(function (k) {
          var n = dayN[k]; var label = k.slice(5).replace('-', '/');
          return { pct: Math.round(Math.min(dayOk[k], n) / n * 100), s: label + ' · ' + n + ' 题', label: label };
        }) };
      }
      var hist = store.read('tiku-hist', '[]');
      if (!Array.isArray(hist)) hist = [];
      return { mode: 'hist', pts: hist.filter(function (h) { return h && h.n > 0; }).slice(0, 10).reverse()
        .map(function (h) {
          var day = h.d ? localDay(new Date(h.d * 1000)) : '';
          return { pct: Math.max(0, Math.min(100, Math.round((h.ok || 0) / h.n * 100))), s: h.s || '', label: day.slice(5).replace('-', '/') };
        }) };
    }
    /* 绘制层：viewBox 与容器 CSS 像素 1:1（字号 / 命中圈不随卡宽缩放），每点透明命中圈可点 / 可聚焦，
       选中点放大填色并写入 #trend-tip（默认最新一点） */
    var trendSel;
    function trendTip(p) { return String(p.s).replace(/[<>&"]/g, '') + ' · ' + p.pct + '%'; }
    function renderTrend() {
      var card = document.getElementById('trend-card');
      var box = document.getElementById('trend-chart');
      if (!card || !box || box.dataset.filled) return;
      box.dataset.filled = '1';
      var tp = trendPoints();
      var pts = tp.pts;
      if (pts.length < 2) { card.hidden = true; return; }
      var scope = tp.mode === 'day' ? '近 ' + pts.length + ' 个学习日' : '近 ' + pts.length + ' 次练习';
      var sub = document.getElementById('trend-sub');
      if (sub) sub.textContent = '· ' + scope;
      if (!(trendSel >= 0 && trendSel < pts.length)) trendSel = pts.length - 1;
      var W = box.clientWidth || 640; var H = 144; var PADX = 26; var TOP = 22; var BASE = 118;
      var step = (W - PADX * 2) / (pts.length - 1);
      var coords = pts.map(function (p, i) {
        return { x: PADX + i * step, y: BASE - (BASE - TOP) * p.pct / 100, p: p };
      });
      var line = coords.map(function (c) { return c.x + ',' + c.y; }).join(' ');
      var area = PADX + ',' + BASE + ' ' + line + ' ' + (W - PADX) + ',' + BASE;
      var svg = '<svg viewBox="0 0 ' + W + ' ' + H + '" class="block w-full" role="group" aria-label="近 ' + pts.length + (tp.mode === 'day' ? ' 个学习日' : ' 次练习') + '正确率趋势，点位可选">' +
        '<defs><linearGradient id="trend-g" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="var(--color-brand-600, #0d9488)" stop-opacity=".18"/><stop offset="1" stop-color="var(--color-brand-600, #0d9488)" stop-opacity="0"/></linearGradient></defs>' +
        '<line x1="' + PADX + '" y1="' + BASE + '" x2="' + (W - PADX) + '" y2="' + BASE + '" style="stroke:var(--color-line, #e2e8f0)"/>' +
        '<polygon points="' + area + '" fill="url(#trend-g)"/>' +
        '<polyline points="' + line + '" fill="none" stroke="var(--color-brand-600, #0d9488)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        coords.map(function (c, i) {
          var first = i === 0; var last = i === coords.length - 1; var sel = i === trendSel;
          return '<circle cx="' + c.x + '" cy="' + c.y + '" r="' + (sel ? 5.5 : 4) + '" fill="' + (sel ? 'var(--color-brand-600, #0d9488)' : '#fff') + '" stroke="var(--color-brand-600, #0d9488)" stroke-width="2.5"/>' +
            ((first || last) ? '<text x="' + c.x + '" y="' + (c.y - 10) + '" text-anchor="middle" font-size="12" font-weight="600" style="fill:var(--color-ink, #0f172a)" class="tabular-nums">' + c.p.pct + '%</text>' : '') +
            ((first || last) && c.p.label ? '<text x="' + c.x + '" y="' + (BASE + 16) + '" text-anchor="' + (first ? 'start' : 'end') + '" font-size="11" style="fill:var(--color-muted, #64748b)">' + c.p.label + '</text>' : '');
        }).join('') +
        coords.map(function (c, i) {
          return '<circle class="trend-hit" data-i="' + i + '" cx="' + c.x + '" cy="' + c.y + '" r="18" fill="transparent" tabindex="0" role="button" aria-pressed="' + (i === trendSel) + '" aria-label="' + trendTip(c.p) + '"><title>' + trendTip(c.p) + '</title></circle>';
        }).join('') + '</svg>';
      box.innerHTML = svg;
      var tip = document.getElementById('trend-tip');
      if (tip) tip.textContent = trendTip(pts[trendSel]);
      card.classList.remove('hidden');
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var pick = function (e) {
        var hit = e.target && e.target.closest ? e.target.closest('.trend-hit') : null;
        if (!hit) return;
        if (e.type === 'keydown') { if (e.key !== 'Enter' && e.key !== ' ') return; e.preventDefault(); }
        trendSel = +hit.dataset.i;
        delete box.dataset.filled; renderTrend();
        var again = box.querySelector('.trend-hit[data-i="' + trendSel + '"]');
        if (again && e.type === 'keydown') again.focus();
      };
      box.addEventListener('click', pick);
      box.addEventListener('keydown', pick);
      var lastW = W;
      window.addEventListener('resize', function () {
        if (Math.abs(box.clientWidth - lastW) <= 40) return;
        lastW = box.clientWidth; delete box.dataset.filled; renderTrend();
      });
    }
    /* 学习日历热力图：近 12 周 tiku-days */
    function renderHeatmap() {
      var card = document.getElementById('heatmap-card');
      var grid = document.getElementById('heatmap');
      if (!card || !grid || grid.childNodes.length) return;
      var days = store.read('tiku-days', '{}');
      var today = new Date();
      var todayKey = localDay(today);
      var end = new Date(today);
      end.setDate(end.getDate() + (7 - ((end.getDay() + 6) % 7)) - 1); /* 本周日 */
      var start = new Date(end); start.setDate(start.getDate() - 7 * 13 + 1); /* 13 周含本周 */
      var monthN = 0; var active = 0; var any = false;
      var monthPrefix = todayKey.slice(0, 8);
      var cur = new Date(start);
      var week = null;
      while (cur <= end) {
        if ((cur.getDay() + 6) % 7 === 0 || !week) {
          week = document.createElement('div');
          week.className = 'flex flex-col gap-1';
          grid.appendChild(week);
        }
        var k = localDay(cur);
        var future = k > todayKey;
        var n = future ? 0 : (days[k] || 0);
        if (n > 0) { any = true; active++; if (k.slice(0, 8) === monthPrefix) monthN += n; }
        var cell = document.createElement('div');
        var cls = n === 0 ? 'bg-slate-100' : n < 5 ? 'bg-brand-200' : n < 10 ? 'bg-brand-400' : n < 20 ? 'bg-brand-600' : 'bg-brand-800';
        cell.className = 'size-3 rounded-[3px] ' + (future ? 'bg-transparent' : cls) + (k === todayKey ? ' ring-1 ring-brand-700 ring-offset-1' : '');
        if (!future) {
          var lab = k.slice(5).replace('-', '/') + ' · ' + n + ' 题';
          cell.title = lab;
          cell.className += ' cursor-pointer';
          cell.setAttribute('role', 'button');
          cell.setAttribute('tabindex', k === todayKey ? '0' : '-1');
          cell.setAttribute('aria-label', lab + '，查看当日明细');
          cell.dataset.day = k;
        }
        week.appendChild(cell);
        cur.setDate(cur.getDate() + 1);
      }
      if (!any) { grid.textContent = ''; card.hidden = true; return; }
      initHeatmapDetail(grid);
      var streak = 0; var d = new Date();
      if (!days[localDay(d)]) { d.setDate(d.getDate() - 1); }
      while (days[localDay(d)]) { streak++; d.setDate(d.getDate() - 1); }
      var sum = document.getElementById('heatmap-summary');
      if (sum) sum.textContent = (streak > 0 ? '🔥 连续 ' + streak + ' 天 · ' : '') + '本月 ' + monthN + ' 题 · 活跃 ' + active + ' 天';
      card.classList.remove('hidden');
    }
    /* 热力图当日明细：点击格子显示 做题数/时长/当日练习记录（纯本地聚合） */
    function initHeatmapDetail(grid) {
      if (grid.dataset.detail) return;
      grid.dataset.detail = '1';
      var box = document.createElement('div');
      box.className = 'mt-3 hidden rounded-xl border border-line bg-slate-50 p-3';
      grid.parentNode.appendChild(box);
      var openKey = '';
      function close() { openKey = ''; box.classList.add('hidden'); box.textContent = ''; }
      function open(k) {
        openKey = k;
        box.textContent = '';
        var days = store.read('tiku-days', '{}');
        var mins = store.read('tiku-mins', '{}');
        var head = document.createElement('div');
        head.className = 'flex items-center justify-between gap-3';
        var t = document.createElement('p');
        t.className = 'text-[13px] font-semibold';
        t.textContent = k.slice(5).replace('-', '/') + ' 学习明细';
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'text-[13px] text-muted hover:text-ink';
        x.textContent = '收起';
        x.addEventListener('click', close);
        head.appendChild(t); head.appendChild(x);
        box.appendChild(head);
        var m = Math.round((mins[k] || 0) / 60);
        var sumLine = document.createElement('p');
        sumLine.className = 'mt-1 text-[13px] text-muted';
        sumLine.textContent = '做题 ' + (days[k] || 0) + ' 题' + (m > 0 ? ' · 练习 ' + m + ' 分钟' : '');
        box.appendChild(sumLine);
        var recs = store.read('tiku-hist', '[]').filter(function (r) {
          return r && r.d && localDay(new Date(r.d * 1000)) === k;
        });
        if (recs.length === 0) {
          var none = document.createElement('p');
          none.className = 'mt-2 text-[13px] text-muted';
          none.textContent = '当天无练习记录';
          box.appendChild(none);
        } else {
          recs.forEach(function (r) {
            var row = document.createElement('p');
            row.className = 'mt-2 flex items-baseline justify-between gap-3 text-[13px]';
            var name = document.createElement('span');
            name.className = 'line-clamp-1 text-ink';
            name.textContent = String(r.t || '练习');
            var meta = document.createElement('span');
            meta.className = 'shrink-0 tabular-nums text-muted';
            var mm = Math.floor((r.u || 0) / 60); var ss = (r.u || 0) % 60;
            meta.textContent = r.ok + '/' + r.n + ' · ' + (mm > 0 ? mm + ' 分 ' : '') + ss + ' 秒';
            row.appendChild(name); row.appendChild(meta);
            box.appendChild(row);
          });
        }
        box.classList.remove('hidden');
      }
      function onPick(e) {
        var el = e.target && e.target.closest ? e.target.closest('[data-day]') : null;
        if (!el) return;
        var k = el.dataset.day;
        if (k === openKey) { close(); return; }
        open(k);
      }
      grid.addEventListener('click', onPick);
      /* roving tabindex：日历只占一个 Tab 停靠点，←/→ 跨周、↑/↓ 逐日、Home/End 首末 */
      var STEP = { ArrowLeft: -7, ArrowRight: 7, ArrowUp: -1, ArrowDown: 1 };
      grid.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { onPick(e); e.preventDefault(); return; }
        var delta = STEP[e.key];
        if (delta === undefined && e.key !== 'Home' && e.key !== 'End') return;
        var cells = Array.prototype.slice.call(grid.querySelectorAll('[data-day]'));
        var cur = e.target && e.target.closest ? e.target.closest('[data-day]') : null;
        var i = cells.indexOf(cur);
        if (i < 0 || cells.length === 0) return;
        var j = e.key === 'Home' ? 0 : e.key === 'End' ? cells.length - 1 : Math.max(0, Math.min(cells.length - 1, i + delta));
        if (j === i) { e.preventDefault(); return; }
        cur.setAttribute('tabindex', '-1');
        cells[j].setAttribute('tabindex', '0');
        cells[j].focus();
        e.preventDefault();
      });
    }
    function removeFrom(key, slug) {
      var l = store.readList(key);
      var i = l.indexOf('/q/' + slug + '/');
      if (i >= 0) { l.splice(i, 1); store.write(key, l); }
      if (key === 'tiku-fav') { document.getElementById('stat-fav').textContent = String(l.map(toSlug).filter(Boolean).length); }
    }
    function pill(text) {
      var s = document.createElement('span');
      s.className = 'rounded-full bg-slate-100 px-2 py-0.5';
      s.textContent = text;
      return s;
    }
    function updateRefreshLink(key) {
      var a = document.getElementById(key === 'tiku-fav' ? 'fav-refresh' : 'wrong-refresh'); if (!a) return;
      var slugs = store.readList(key).map(toSlug).filter(Boolean);
      if (slugs.length === 0) { a.hidden = true; return; }
      var recent = slugs.slice(-20).reverse();
      if (key === 'tiku-wrong') recent = shuffleSlugs(recent);
      a.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(recent.join(','));
      a.textContent = a.textContent.replace(/（[^）]*）$/, '') + (slugs.length > 20 ? '（最近 20 题）' : '（' + slugs.length + ' 题）');
    }
    /* 单卡移除后的统一清理：存储、组头计数/连刷链接、chips、重刷链接、空态（✕ 与批量管理共用） */
    function detachCard(wrap, key, emptyId, listId) {
      removeFrom(key, wrap.dataset.cardSlug);
      var grid = wrap.parentNode; wrap.remove();
      if (chipsRefresh[key]) chipsRefresh[key]();
      if (insightRefresh[key]) insightRefresh[key]();
      var sec = grid ? grid.parentNode : null;
      if (grid && sec) {
        if (grid.children.length === 0) { sec.remove(); }
        else {
          var h = sec.querySelector('p');
          if (h) h.textContent = h.textContent.replace(/（\d+）/, '（' + grid.children.length + '）');
          var run = sec.querySelector('a[href^="/practice/"]');
          if (run) {
            var left = Array.prototype.slice.call(grid.children).map(function (w) { return w.dataset.cardSlug; }).filter(Boolean);
            run.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(left.slice(0, 50).join(','));
            delete run.dataset.hrefAll;
          }
        }
      }
      updateRefreshLink(key);
      var root = document.getElementById(listId);
      if (root && root.querySelectorAll('[data-card-slug]').length === 0) {
        document.getElementById(emptyId).style.display = '';
        var mbtn = document.getElementById(key === 'tiku-fav' ? 'fav-manage' : 'wrong-manage');
        if (mbtn) mbtn.hidden = true;
      }
    }
    /* 题图 SVG 白名单（与 practice.js safeSvg / src/lib.ts isSafeSvg 同规则：my.js 与 practice.js 不共享闭包） */
    var SVG_TAGS = { svg: 1, g: 1, path: 1, rect: 1, circle: 1, ellipse: 1, line: 1, polyline: 1, polygon: 1, text: 1, title: 1 };
    function safeSvg(s) {
      if (typeof s !== 'string' || !s || s.length > 20000) return false;
      var t = s.trim();
      if (t.slice(0, 4) !== '<svg' || t.slice(-6) !== '</svg>') return false;
      if (/<!--|<!\[CDATA\[|<\?|&#|javascript:/i.test(t)) return false;
      var re = /<\s*\/?\s*([a-zA-Z][\w:-]*)([^>]*)>/g; var m;
      while ((m = re.exec(t)) !== null) {
        if (!SVG_TAGS[m[1].toLowerCase()]) return false;
        if (/(^|\s)(on[a-z]+|href|xlink:href|style|src)\s*=/i.test(m[2])) return false;
      }
      return true;
    }
    function card(q, key, emptyId, listId) {
      var wrap = document.createElement('div'); wrap.className = 'relative'; wrap.dataset.cardSlug = q.slug;
      var a = document.createElement('a');
      a.href = '/q/' + q.slug + '/';
      a.className = 'block rounded-xl border border-line bg-white p-4 pr-10 shadow-sm transition hover:border-brand-600/40 hover:shadow-md';
      var head = document.createElement('div'); head.className = 'flex items-start gap-3';
      var stem = document.createElement('p'); stem.className = 'min-w-0 flex-1 line-clamp-2 text-[15px] leading-relaxed text-ink'; stem.textContent = q.stem;
      head.appendChild(stem);
      if (safeSvg(q.fig)) {
        var th = document.createElement('div'); th.className = 'qz-fig w-24 shrink-0 rounded-lg border border-line bg-white p-1.5';
        th.innerHTML = q.fig; th.setAttribute('aria-hidden', 'true');
        head.appendChild(th);
      }
      var meta = document.createElement('p'); meta.className = 'js-card-meta mt-2 flex flex-wrap items-center gap-2 text-[13px] text-slate-600';
      if (q.subject_name) { meta.appendChild(pill(q.subject_name)); }
      meta.appendChild(pill(QTYPE[q.qtype] || q.qtype));
      var d = document.createElement('span'); d.textContent = '难度 ' + stars(q.difficulty);
      meta.appendChild(d); a.appendChild(head); a.appendChild(meta);
      var btn = document.createElement('button');
      btn.type = 'button'; btn.textContent = '✕';
      btn.className = 'absolute right-1 top-1 grid size-10 place-items-center rounded-lg text-slate-500 hover:bg-slate-100 hover:text-slate-700';
      btn.setAttribute('aria-label', key === 'tiku-fav' ? '取消收藏' : '移出错题本');
      btn.addEventListener('click', function () { detachCard(wrap, key, emptyId, listId); });
      wrap.appendChild(a); wrap.appendChild(btn);
      return wrap;
    }
    /* 错题本/收藏夹筛选 chips：考点行 + 难度行（易/中/难），两行交集过滤并可连刷 */
    var chipsRefresh = {};
    var insightRefresh = {};
    function buildKpChips(listId, chips, key) {
      var box = document.getElementById(chips.kp); if (!box) return;
      var sbox = chips.subj ? document.getElementById(chips.subj) : null;
      var dbox = document.getElementById(chips.diff);
      var tbox = chips.qtype ? document.getElementById(chips.qtype) : null;
      var rbox = chips.reason ? document.getElementById(chips.reason) : null;
      var list = document.getElementById(listId);
      var selected = ''; var selSubj = ''; var selDiff = ''; var selQtype = ''; var selReason = ''; var selKw = ''; var selDue = false;
      var kwBar = null; var kwTip = null; var dueBar = null;
      function wraps() { return Array.prototype.slice.call(list.querySelectorAll('[data-card-slug]')); }
      function matches(w) {
        if (selected && (w.dataset.kp || '未标注') !== selected) return false;
        if (selSubj && (w.dataset.subj || '') !== selSubj) return false;
        if (selDiff && (w.dataset.diff || '') !== selDiff) return false;
        if (selQtype && (w.dataset.qtype || '') !== selQtype) return false;
        if (selReason && (w.dataset.reason || '') !== selReason) return false;
        if (selDue && w.dataset.due !== '1') return false;
        if (selKw) {
          var np = w.querySelector('a p.line-clamp-1');
          var hay = ((w.dataset.stem || '') + ' ' + (np ? np.textContent : '')).toLowerCase();
          if (hay.indexOf(selKw) < 0) return false;
        }
        return true;
      }
      function apply() {
        wraps().forEach(function (w) { w.hidden = !matches(w); });
        var filtering = !!(selected || selSubj || selDiff || selQtype || selReason || selKw || selDue);
        Array.prototype.slice.call(list.children).forEach(function (sec) {
          var g = sec.querySelector('[data-card-slug]'); if (!g) return;
          var vis = Array.prototype.slice.call(sec.querySelectorAll('[data-card-slug]:not([hidden])'));
          sec.hidden = vis.length === 0;
          var h = sec.querySelector('p');
          if (h) h.textContent = h.textContent.replace(/（\d+）/, '（' + vis.length + '）');
          var run = sec.querySelector('a[href^="/practice/"]');
          if (run) {
            if (filtering) {
              if (!run.dataset.hrefAll) run.dataset.hrefAll = run.getAttribute('href');
              var vs = vis.map(function (w) { return w.dataset.cardSlug; }).filter(Boolean);
              run.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(vs.slice(0, 50).join(','));
            } else if (run.dataset.hrefAll) { run.href = run.dataset.hrefAll; delete run.dataset.hrefAll; }
          }
        });
        if (kwTip) kwTip.hidden = !(selKw && wraps().filter(matches).length === 0);
      }
      /* 关键词搜索（题干/笔记）：卡片 ≥6 才渲染，与 chips 三行交集过滤 */
      function renderKw() {
        if (wraps().length < 6) { if (kwBar) { kwBar.hidden = true; selKw = ''; } return; }
        if (kwBar) { kwBar.hidden = false; return; }
        kwBar = document.createElement('div');
        kwBar.className = 'mb-2 flex items-center gap-2';
        var inp = document.createElement('input');
        inp.type = 'search';
        inp.id = 'wrong-kw'; inp.name = 'kw';
        inp.placeholder = '搜索题干/笔记关键词';
        inp.setAttribute('aria-label', '搜索' + ((chips && chips.noun) || '题目') + '题干或笔记关键词');
        inp.className = 'h-10 md:h-9 w-full max-w-xs rounded-full border border-line bg-white px-3.5 text-sm text-ink placeholder:text-muted focus:border-brand-600/60 focus:outline-hidden focus:ring-2 focus:ring-brand-600/40';
        inp.addEventListener('input', function () { selKw = inp.value.trim().toLowerCase(); render(); });
        kwBar.appendChild(inp);
        kwTip = document.createElement('span');
        kwTip.className = 'whitespace-nowrap text-[13px] text-muted';
        kwTip.textContent = '无匹配';
        kwTip.hidden = true;
        kwBar.appendChild(kwTip);
        box.parentNode.insertBefore(kwBar, box);
      }
      function chip(parent, label, on, onClick) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'inline-flex h-10 md:h-9 items-center rounded-full border px-3 text-sm ' + (on ? 'border-brand-700 bg-brand-700 font-medium text-white' : 'border-line bg-white text-slate-600 hover:bg-brand-50');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.textContent = label;
        b.addEventListener('click', onClick);
        parent.appendChild(b);
      }
      function runLink(parent, label) {
        var run = document.createElement('a');
        var sl = wraps().filter(matches).map(function (w) { return w.dataset.cardSlug; }).slice(0, 50);
        if (key === 'tiku-wrong') sl = shuffleSlugs(sl);
        run.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(sl.join(','));
        run.className = 'inline-flex h-10 md:h-9 items-center px-1 text-sm font-medium text-brand-700 hover:underline';
        run.textContent = label;
        parent.appendChild(run);
      }
      /* 待复习筛选：仅错题本，有到期卡且未全到期才渲染（与其余维度交集） */
      function renderDue() {
        if (key !== 'tiku-wrong') return;
        var n = wraps().filter(function (w) { return w.dataset.due === '1'; }).length;
        if (n === 0 || n === wraps().length) { if (dueBar) dueBar.hidden = true; selDue = false; return; }
        if (!dueBar) {
          dueBar = document.createElement('div');
          dueBar.className = 'mb-2 flex flex-wrap items-center gap-2';
          box.parentNode.insertBefore(dueBar, kwBar || box);
        }
        dueBar.hidden = false;
        dueBar.textContent = '';
        chip(dueBar, '只看待复习 ' + n, selDue, function () { selDue = !selDue; render(); });
        if (selDue) runLink(dueBar, '连刷待复习' + chips.noun + ' →');
      }
      function render() {
        renderKw();
        renderDue();
        var counts = {}; var order = [];
        wraps().forEach(function (w) {
          var k = w.dataset.kp || '未标注';
          if (!counts[k]) { counts[k] = 0; order.push(k); }
          counts[k] += 1;
        });
        order.sort(function (x, y) { return counts[y] - counts[x]; });
        if (order.length < 2) { box.classList.add('hidden'); box.classList.remove('flex'); selected = ''; }
        else {
          if (selected && !counts[selected]) selected = '';
          box.textContent = '';
          var total = wraps().length;
          var items = [{ k: '', label: '全部（' + total + '）' }].concat(order.slice(0, 12).map(function (k) { return { k: k, label: k + ' ' + counts[k] }; }));
          items.forEach(function (it) {
            chip(box, it.label, selected === it.k, function () { selected = selected === it.k ? '' : it.k; render(); });
          });
          if (selected) runLink(box, (selSubj || selDiff || selQtype || selReason) ? '连刷筛选' + chips.noun + ' →' : '连刷该考点' + chips.noun + ' →');
          box.classList.remove('hidden'); box.classList.add('flex');
        }
        renderSubj();
        renderDiff();
        renderQtype();
        renderReason();
        apply();
        updatePrint();
      }
      function renderDiff() {
        if (!dbox) return;
        var bands = ['易', '中', '难'];
        var dc = {};
        wraps().forEach(function (w) { var d = w.dataset.diff || ''; if (d) dc[d] = (dc[d] || 0) + 1; });
        var present = bands.filter(function (b) { return dc[b] > 0; });
        if (present.length < 2) { dbox.classList.add('hidden'); dbox.classList.remove('flex'); selDiff = ''; return; }
        if (selDiff && !dc[selDiff]) selDiff = '';
        dbox.textContent = '';
        chip(dbox, '全部难度', selDiff === '', function () { selDiff = ''; render(); });
        present.forEach(function (b) {
          chip(dbox, '难度·' + b + ' ' + dc[b], selDiff === b, function () { selDiff = selDiff === b ? '' : b; render(); });
        });
        if (selDiff) runLink(dbox, (selected || selSubj || selQtype || selReason) ? '连刷筛选' + chips.noun + ' →' : '连刷该难度' + chips.noun + ' →');
        dbox.classList.remove('hidden'); dbox.classList.add('flex');
      }
      /* 科目行：≥2 个科目有题才渲染，与其余维度交集 */
      function renderSubj() {
        if (!sbox) return;
        var sc = {}; var sorder = [];
        wraps().forEach(function (w) {
          var s = w.dataset.subj || '';
          if (!s) return;
          if (!sc[s]) { sc[s] = 0; sorder.push(s); }
          sc[s] += 1;
        });
        if (sorder.length < 2) { sbox.classList.add('hidden'); sbox.classList.remove('flex'); selSubj = ''; return; }
        if (selSubj && !sc[selSubj]) selSubj = '';
        sorder.sort(function (x, y) { return sc[y] - sc[x]; });
        sbox.textContent = '';
        chip(sbox, '全部科目', selSubj === '', function () { selSubj = ''; render(); });
        sorder.slice(0, 8).forEach(function (s) {
          chip(sbox, s + ' ' + sc[s], selSubj === s, function () { selSubj = selSubj === s ? '' : s; render(); });
        });
        if (selSubj) runLink(sbox, (selected || selDiff || selQtype || selReason) ? '连刷筛选' + chips.noun + ' →' : '连刷该科目' + chips.noun + ' →');
        sbox.classList.remove('hidden'); sbox.classList.add('flex');
      }
      /* 题型行：单选/多选/判断/材料，≥2 个题型有题才渲染，与其余维度交集 */
      function renderQtype() {
        if (!tbox) return;
        var tc = {}; var torder = [];
        wraps().forEach(function (w) {
          var t = w.dataset.qtype || '';
          if (!t) return;
          if (!tc[t]) { tc[t] = 0; torder.push(t); }
          tc[t] += 1;
        });
        if (torder.length < 2) { tbox.classList.add('hidden'); tbox.classList.remove('flex'); selQtype = ''; return; }
        if (selQtype && !tc[selQtype]) selQtype = '';
        tbox.textContent = '';
        chip(tbox, '全部题型', selQtype === '', function () { selQtype = ''; render(); });
        torder.forEach(function (t) {
          chip(tbox, t + ' ' + tc[t], selQtype === t, function () { selQtype = selQtype === t ? '' : t; render(); });
        });
        if (selQtype) runLink(tbox, (selected || selSubj || selDiff || selReason) ? '连刷筛选' + chips.noun + ' →' : '连刷该题型' + chips.noun + ' →');
        tbox.classList.remove('hidden'); tbox.classList.add('flex');
      }
      /* 错因行：粗心/审题/知识/计算/未标注，与考点、难度三行交集过滤 */
      function renderReason() {
        if (!rbox) return;
        var rc = {};
        wraps().forEach(function (w) { var c = w.dataset.reason || 'wu'; rc[c] = (rc[c] || 0) + 1; });
        var cats = REASONS.map(function (r) { return { k: r[0], label: r[1] }; }).concat([{ k: 'wu', label: '未标注' }])
          .filter(function (c) { return rc[c.k] > 0; });
        if (cats.length < 2) { rbox.classList.add('hidden'); rbox.classList.remove('flex'); selReason = ''; return; }
        if (selReason && !rc[selReason]) selReason = '';
        rbox.textContent = '';
        chip(rbox, '全部错因', selReason === '', function () { selReason = ''; render(); });
        cats.forEach(function (c) {
          chip(rbox, '错因·' + c.label + ' ' + rc[c.k], selReason === c.k, function () { selReason = selReason === c.k ? '' : c.k; render(); });
        });
        if (selReason) runLink(rbox, (selected || selSubj || selDiff || selQtype) ? '连刷筛选' + chips.noun + ' →' : '连刷该错因' + chips.noun + ' →');
        rbox.classList.remove('hidden'); rbox.classList.add('flex');
      }
      function updatePrint() {
        if (!chips.print) return;
        var a = document.getElementById(chips.print); if (!a) return;
        var sl = wraps().filter(matches).map(function (w) { return w.dataset.cardSlug; }).slice(0, 50);
        if (sl.length === 0) { a.hidden = true; return; }
        a.href = '/print/?slugs=' + encodeURIComponent(sl.join(',')) + (chips.noun === '收藏' ? '&kind=fav' : '');
        a.hidden = false;
      }
      chipsRefresh[key] = render;
      render();
    }
    /* 管理模式：批量选择移出（错题本/收藏夹共用，移出路径与单卡 ✕ 同一 detachCard） */
    var manageRescan = {};
    function initManage(cfg) {
      var btn = document.getElementById(cfg.key === 'tiku-fav' ? 'fav-manage' : 'wrong-manage');
      var list = document.getElementById(cfg.listId);
      if (!btn || !list) return;
      var on = false; var bar = null;
      function wraps() { return Array.prototype.slice.call(list.querySelectorAll('[data-card-slug]')); }
      function selected() { return wraps().filter(function (w) { return w.dataset.sel === '1'; }); }
      function mark(w, sel) {
        w.dataset.sel = sel ? '1' : '';
        var ov = w.querySelector('.js-sel-ov'); if (!ov) return;
        ov.className = 'js-sel-ov absolute inset-0 z-10 grid place-items-center rounded-xl text-3xl font-bold ' +
          (sel ? 'border-2 border-brand-600 bg-brand-600/10 text-brand-700' : 'border-2 border-dashed border-brand-300 text-transparent');
        ov.setAttribute('aria-pressed', sel ? 'true' : 'false');
      }
      function addOv(w) {
        if (w.querySelector('.js-sel-ov')) return;
        var ov = document.createElement('button');
        ov.type = 'button'; ov.textContent = '✓';
        ov.className = 'js-sel-ov';
        ov.setAttribute('aria-label', '选择本题');
        w.appendChild(ov);
        mark(w, w.dataset.sel === '1');
        ov.addEventListener('click', function () { mark(w, w.dataset.sel !== '1'); updateBar(); });
      }
      function updateBar() {
        if (!bar) return;
        var n = selected().length;
        var rm = bar.querySelector('.js-sel-rm');
        rm.textContent = '移出所选（' + n + '）';
        rm.disabled = n === 0;
      }
      function rescan() { if (!on) return; wraps().forEach(addOv); updateBar(); }
      function exit() {
        on = false; btn.textContent = '管理';
        Array.prototype.slice.call(list.querySelectorAll('.js-sel-ov')).forEach(function (o) { o.remove(); });
        wraps().forEach(function (w) { w.dataset.sel = ''; });
        if (bar) { bar.remove(); bar = null; }
      }
      function enter() {
        on = true; btn.textContent = '退出管理';
        bar = document.createElement('div');
        bar.className = 'mb-3 flex flex-wrap items-center gap-2 rounded-xl border border-brand-200 bg-brand-50 px-3 py-2';
        var all = document.createElement('button');
        all.type = 'button'; all.textContent = '全选可见';
        all.className = 'inline-flex h-10 md:h-9 items-center rounded-lg border border-line bg-white px-3 text-sm font-medium text-slate-700 hover:bg-slate-50';
        all.addEventListener('click', function () {
          var vis = wraps().filter(function (w) { return !w.hidden; });
          var everySel = vis.length > 0 && vis.every(function (w) { return w.dataset.sel === '1'; });
          vis.forEach(function (w) { mark(w, !everySel); });
          updateBar();
        });
        var rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'js-sel-rm inline-flex h-10 md:h-9 items-center rounded-lg bg-red-600 px-3 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-40';
        rm.addEventListener('click', function () {
          var sel = selected(); if (sel.length === 0) return;
          if (!window.confirm('确定' + (cfg.key === 'tiku-fav' ? '取消收藏' : '移出错题本') + '所选 ' + sel.length + ' 题？')) return;
          sel.forEach(function (w) { detachCard(w, cfg.key, cfg.emptyId, cfg.listId); });
          if (wraps().length === 0) { exit(); } else { updateBar(); }
        });
        var done = document.createElement('button');
        done.type = 'button'; done.textContent = '完成';
        done.className = 'inline-flex h-10 md:h-9 items-center rounded-lg border border-line bg-white px-3 text-sm font-medium text-brand-700 hover:bg-brand-50';
        done.addEventListener('click', exit);
        bar.appendChild(all); bar.appendChild(rm); bar.appendChild(done);
        list.parentNode.insertBefore(bar, list);
        rescan();
      }
      manageRescan[cfg.key] = rescan;
      btn.addEventListener('click', function () { if (on) exit(); else enter(); });
    }
    /* 错题本/收藏夹：按考试线分组，组头「连刷本组」，错题另带「错 N 次」徽标与「同考点再刷」直达 */
    function fillGrouped(slugs, cfg) {
      if (slugs.length === 0) return;
      initManage(cfg);
      var BATCH = 60;
      var all = slugs.slice().reverse();
      var shown = 0;
      var started = false;
      var groupIdx = {};
      var fetched = [];
      var moreBtn = null;
      var list = document.getElementById(cfg.listId);
      function appendCard(q, grid, wrongN, wrongK, pickMap) {
        var wrap = card(q, cfg.key, cfg.emptyId, cfg.listId);
        wrap.dataset.stem = q.stem || '';
        var nt = readNotes()[q.slug];
        var np = null;
        function syncNoteLine(text) {
          var t = String(text || '').replace(/\s+$/, '');
          if (t) {
            if (!np) {
              np = document.createElement('p');
              np.className = 'mt-2 line-clamp-1 rounded bg-amber-50 px-2 py-1 text-[13px] text-amber-800';
              wrap.querySelector('a').appendChild(np);
            }
            np.textContent = '📝 ' + t;
          } else if (np) { np.remove(); np = null; }
        }
        if (nt && nt.t) { syncNoteLine(nt.t); }
        /* 就地记笔记：复用 bindNote 去抖自动保存，编辑器在 <a> 外点击不跳题 */
        var noteBtn = document.createElement('button');
        noteBtn.type = 'button'; noteBtn.textContent = '✎';
        noteBtn.className = 'absolute right-1 top-11 grid size-10 place-items-center rounded-lg text-slate-500 hover:bg-slate-100 hover:text-slate-700';
        noteBtn.setAttribute('aria-label', nt && nt.t ? '编辑笔记' : '记笔记');
        var editor = null;
        noteBtn.addEventListener('click', function () {
          if (editor) { editor.remove(); editor = null; return; }
          editor = document.createElement('div');
          editor.className = 'mt-2 rounded-xl border border-line bg-white p-3 shadow-sm';
          var ta = document.createElement('textarea');
          ta.className = 'w-full resize-y rounded-lg border border-line px-3 py-2 text-[14px] text-ink focus:border-brand-600 focus:outline-hidden';
          ta.rows = 3; ta.maxLength = 1000; ta.placeholder = '记录解题思路 / 易错点…';
          var msg = document.createElement('p');
          msg.className = 'mt-1 text-[12px] text-muted';
          msg.textContent = '自动保存 · 仅保存在本浏览器';
          bindNote(ta, msg, q.slug);
          ta.addEventListener('input', function () { syncNoteLine(ta.value); });
          editor.appendChild(ta); editor.appendChild(msg);
          wrap.appendChild(editor);
          ta.focus();
        });
        wrap.appendChild(noteBtn);
        if (cfg.chips) {
          wrap.dataset.kp = (q.kp_names || '').split('|')[0] || '未标注';
          var dv = Number(q.difficulty);
          wrap.dataset.diff = dv >= 1 ? (dv <= 2 ? '易' : dv <= 3 ? '中' : '难') : '';
          wrap.dataset.qtype = QTYPE[q.qtype] || '';
          wrap.dataset.subj = q.subject_name || '';
          if (cfg.reasons) wrap.dataset.reason = store.read('tiku-wrongr', '{}')[q.slug] || 'wu';
        }
        if (wrongN && (wrongN[q.slug] || 0) >= 2) {
          var nb = document.createElement('span');
          nb.className = 'rounded-full bg-amber-100 px-2 py-0.5 font-medium text-amber-700';
          nb.textContent = '错 ' + wrongN[q.slug] + ' 次';
          var metaRow = wrap.querySelector('a > p.js-card-meta');
          if (metaRow) metaRow.appendChild(nb);
        }
        if (wrongK) {
          var metaRow2 = wrap.querySelector('a > p.js-card-meta');
          /* 上次作答（tiku-pick）：错题本卡只示我选了什么，不直出答案（间隔复习待再答） */
          var pk = pickMap && pickMap[q.slug];
          if (metaRow2 && /^[A-H]{1,8}$/.test(pk)) {
            var pb = document.createElement('span');
            pb.className = 'tabular-nums';
            pb.textContent = '上次选 ' + pk;
            metaRow2.appendChild(pb);
          }
          var kb = document.createElement('span');
          kb.className = 'rounded-full bg-brand-50 px-2 py-0.5 font-medium text-brand-700';
          kb.textContent = '复习 ' + Math.min(3, (wrongK['/q/' + q.slug + '/'] || 0) + 1) + '/3';
          if (metaRow2) metaRow2.appendChild(kb);
          /* 到期徽标：距最后答错/复习 ≥ 当前轮次间隔（契约与 wrongDue 一致） */
          var dueP = '/q/' + q.slug + '/';
          var dueT = store.read('tiku-wrongt', '{}')[dueP];
          var dueGaps = [86400, 259200, 604800];
          var dueOk = typeof dueT !== 'number' || Math.floor(Date.now() / 1000) - dueT >= dueGaps[Math.max(0, Math.min(2, wrongK[dueP] || 0))];
          if (dueOk && metaRow2) {
            var db = document.createElement('span');
            db.className = 'js-due-badge rounded-full bg-amber-100 px-2 py-0.5 font-medium text-amber-800';
            db.textContent = '待复习';
            metaRow2.appendChild(db);
            wrap.dataset.due = '1';
          } else if (metaRow2) {
            var leftD = Math.ceil((dueGaps[Math.max(0, Math.min(2, wrongK[dueP] || 0))] - (Math.floor(Date.now() / 1000) - dueT)) / 86400);
            var nb2 = document.createElement('span');
            nb2.className = 'js-next-badge rounded-full bg-slate-100 px-2 py-0.5 text-slate-600';
            nb2.textContent = leftD + ' 天后复习';
            metaRow2.appendChild(nb2);
          }
        }
        if (cfg.badges && q.kp_slug && q.exam_slug && q.subject_slug) {
          var inner = wrap.querySelector('a');
          inner.classList.remove('rounded-xl'); inner.classList.add('rounded-t-xl');
          var kp = document.createElement('a');
          kp.href = '/kaoshi/' + q.exam_slug + '/' + q.subject_slug + '/kp/' + q.kp_slug + '/';
          kp.className = 'flex min-h-10 items-center rounded-b-xl border border-t-0 border-line bg-slate-50 px-4 py-2 text-[13px] font-medium text-brand-700 hover:bg-brand-50';
          kp.textContent = '同考点再刷：' + ((q.kp_names || '').split('|')[0] || '相关知识点') + '\u00a0→';
          wrap.appendChild(kp);
        }
        if (cfg.reasons) {
          var lastEl = wrap.lastElementChild;
          if (lastEl && lastEl.classList.contains('rounded-b-xl')) { lastEl.classList.remove('rounded-b-xl'); }
          else if (lastEl && lastEl.classList.contains('rounded-xl')) { lastEl.classList.remove('rounded-xl'); lastEl.classList.add('rounded-t-xl'); }
          wrap.appendChild(reasonRow(q.slug));
        }
        grid.appendChild(wrap);
      }
      function groupSec(g) {
        if (groupIdx[g]) return groupIdx[g];
        var sec = document.createElement('div');
        var head = document.createElement('div');
        head.className = 'mb-2 flex items-center justify-between gap-2';
        var h = document.createElement('p');
        h.className = 'text-sm font-semibold text-slate-700';
        head.appendChild(h);
        var run = document.createElement('a');
        run.className = 'inline-flex min-h-10 items-center text-[13px] font-medium text-brand-700 hover:underline';
        run.textContent = '连刷本组 →';
        head.appendChild(run);
        sec.appendChild(head);
        var grid = document.createElement('div'); grid.className = 'grid gap-3 md:grid-cols-2';
        sec.appendChild(grid);
        if (moreBtn) list.insertBefore(sec, moreBtn); else list.appendChild(sec);
        groupIdx[g] = { arr: [], h: h, run: run, grid: grid };
        return groupIdx[g];
      }
      function updateMore() {
        var left = all.length - shown;
        if (left <= 0) { if (moreBtn) { moreBtn.remove(); moreBtn = null; } return; }
        if (!moreBtn) {
          moreBtn = document.createElement('button');
          moreBtn.type = 'button';
          moreBtn.className = 'mt-3 inline-flex h-10 items-center rounded-lg border border-line bg-white px-4 text-sm font-medium text-brand-700 hover:bg-brand-50';
          moreBtn.addEventListener('click', function () { loadBatch(); });
          list.appendChild(moreBtn);
        }
        moreBtn.textContent = '加载更早的' + ((cfg.chips && cfg.chips.noun) || '题目') + '（还有 ' + left + ' 条）';
        moreBtn.disabled = false;
      }
      function loadBatch() {
        var next = all.slice(shown, shown + BATCH);
        if (next.length === 0) return;
        if (moreBtn) moreBtn.disabled = true;
        var req = fetch('/api/questions?slugs=' + encodeURIComponent(next.join(',')) + '&fig=1')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            shown += next.length;
            var byS = {}; (d.items || []).forEach(function (q) { byS[q.slug] = q; });
            var wrongN = cfg.badges ? store.read('tiku-wrongn', '{}') : null;
            var wrongK = cfg.badges ? store.read('tiku-wrongk', '{}') : null;
            var pickMap = cfg.badges ? store.read('tiku-pick', '{}') : null;
            if (pickMap && (typeof pickMap !== 'object' || Array.isArray(pickMap))) pickMap = null;
            var got = false;
            next.forEach(function (s) {
              var q = byS[s]; if (!q) return;
              got = true;
              fetched.push(q);
              var g = q.exam_name || '其他';
              var sec = groupSec(g);
              sec.arr.push(q);
              sec.h.textContent = g + '（' + sec.arr.length + '）';
              var gsl = sec.arr.slice(0, 50).map(function (q2) { return q2.slug; });
              if (cfg.key === 'tiku-wrong') gsl = shuffleSlugs(gsl);
              sec.run.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(gsl.join(','));
              delete sec.run.dataset.hrefAll;
              appendCard(q, sec.grid, wrongN, wrongK, pickMap);
            });
            updateMore();
            if (!got) return;
            document.getElementById(cfg.emptyId).style.display = 'none';
            var mb = document.getElementById(cfg.key === 'tiku-fav' ? 'fav-manage' : 'wrong-manage');
            if (mb) mb.hidden = false;
            if (manageRescan[cfg.key]) manageRescan[cfg.key]();
            if (cfg.chips) {
              if (!started) buildKpChips(cfg.listId, cfg.chips, cfg.key);
              else if (chipsRefresh[cfg.key]) chipsRefresh[cfg.key]();
            }
            if (cfg.insight) {
              insightRefresh[cfg.key] = function () {
                var cur = store.readList(cfg.key).map(toSlug).filter(Boolean); var keep = {};
                cur.forEach(function (s) { keep[s] = 1; });
                renderWrongInsight(cur, fetched.filter(function (q) { return keep[q.slug]; }));
              };
              insightRefresh[cfg.key]();
            }
            if (cfg.badges) injectQstats(next);
            started = true;
          }).catch(function () { if (moreBtn) moreBtn.disabled = false; });
        if (!started) trackFill(req);
      }
      /* 全站正确率社会参照：每批卡片按 qstats 上限 20 分片拉取，attempts≥5 才展示，<50% 加易错徽标 */
      function injectQstats(batch) {
        for (var i = 0; i < batch.length; i += 20) {
          fetch('/api/qstats?slugs=' + encodeURIComponent(batch.slice(i, i + 20).join(',')))
            .then(function (r) { return r.json(); })
            .then(function (d) {
              (d.items || []).forEach(function (it) {
                if (it.attempts < 5) return;
                var wrapEl = list.querySelector('[data-card-slug="' + it.slug + '"]');
                var metaEl = wrapEl && wrapEl.querySelector('a > p.js-card-meta');
                if (!metaEl || metaEl.querySelector('.js-card-qstat')) return;
                var pct = Math.round(it.correct / it.attempts * 100);
                var sp = document.createElement('span');
                sp.className = 'js-card-qstat rounded-full bg-slate-100 px-2 py-0.5 tabular-nums';
                sp.textContent = '全站 ' + pct + '% 做对';
                metaEl.appendChild(sp);
                if (pct < 50) {
                  var hb = document.createElement('span');
                  hb.className = 'rounded-full bg-red-100 px-2 py-0.5 font-medium text-red-700';
                  hb.textContent = '易错';
                  metaEl.appendChild(hb);
                }
              });
            }).catch(function () { /* noop */ });
        }
      }
      loadBatch();
    }
    /* 错题原因标注：四类原因 chips，点选存 tiku-wrongr {slug:code}，再点取消 */
    var REASONS = [['cx', '粗心大意'], ['st', '审题不清'], ['zs', '知识模糊'], ['js', '计算失误']];
    function reasonLabel(code) {
      for (var i = 0; i < REASONS.length; i++) { if (REASONS[i][0] === code) return REASONS[i][1]; }
      return '';
    }
    function reasonRow(slug) {
      var row = document.createElement('div');
      row.className = 'flex flex-wrap items-center gap-1.5 rounded-b-xl border border-t-0 border-line bg-white px-4 py-2 text-[12px]';
      var lab = document.createElement('span');
      lab.className = 'text-muted';
      lab.textContent = '错因';
      row.appendChild(lab);
      function render() {
        while (row.children.length > 1) row.removeChild(row.lastChild);
        var cur = store.read('tiku-wrongr', '{}')[slug] || '';
        REASONS.forEach(function (r) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = cur === r[0]
            ? 'tap-y rounded-full bg-brand-700 px-2.5 py-0.5 font-medium text-white'
            : 'tap-y rounded-full border border-line bg-slate-50 px-2.5 py-0.5 text-slate-600 hover:bg-brand-50';
          b.textContent = r[1];
          b.addEventListener('click', function () {
            var wr = store.read('tiku-wrongr', '{}');
            if (wr[slug] === r[0]) { delete wr[slug]; } else { wr[slug] = r[0]; }
            store.write('tiku-wrongr', wr);
            var wrapEl = row.closest('[data-card-slug]');
            if (wrapEl && wrapEl.dataset.reason !== undefined) {
              wrapEl.dataset.reason = wr[slug] || 'wu';
              if (chipsRefresh['tiku-wrong']) chipsRefresh['tiku-wrong']();
            }
            render();
          });
          row.appendChild(b);
        });
      }
      render();
      return row;
    }
    /* 错题本维度分析卡：概览 + 考点分布 top5 + 错误原因分布 + 近 4 周新增趋势（全本地数据，<3 题不显示） */
    function renderWrongInsight(allSlugs, items) {
      var box = document.getElementById('wrong-insight');
      if (!box) return;
      box.textContent = '';
      if (allSlugs.length < 3) { box.hidden = true; return; }
      var wn = store.read('tiku-wrongn', '{}');
      var wt = store.read('tiku-wrongt', '{}');
      var hifreq = allSlugs.filter(function (s) { return (wn[s] || 0) >= 2; }).length;
      var due = wrongDue().length;
      function h(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text) n.textContent = text;
        return n;
      }
      box.appendChild(h('p', 'text-sm font-semibold', '错题维度分析'));
      var ov = h('div', 'mt-2 flex flex-wrap gap-x-5 gap-y-1 text-[13px] text-muted');
      ov.appendChild(h('span', '', '错题共 ' + allSlugs.length + ' 题'));
      ov.appendChild(h('span', '', '今日待复习 ' + due + ' 题'));
      ov.appendChild(h('span', '', '高频（错≥2次）' + hifreq + ' 题'));
      box.appendChild(ov);
      var counts = {}; var order = []; var kpQs = {};
      items.forEach(function (q) {
        var k = (q.kp_names || '').split('|')[0] || '未标注';
        if (!counts[k]) { counts[k] = 0; order.push(k); kpQs[k] = []; }
        counts[k] += 1;
        if (q.slug) kpQs[k].push(q.slug);
      });
      order.sort(function (x, y) { return counts[y] - counts[x]; });
      if (order.length >= 2) {
        box.appendChild(h('p', 'mt-3 text-[13px] font-medium text-slate-600', '错得最多的考点（最近 ' + items.length + ' 题）'));
        order.slice(0, 5).forEach(function (k) {
          var pct = Math.round(counts[k] / items.length * 100);
          var row = h('div', 'mt-1.5');
          var head = h('div', 'flex items-baseline gap-3 text-[13px]');
          head.appendChild(h('span', 'min-w-[3em] flex-1 truncate', k));
          if (kpQs[k].length > 0) {
            var drill = document.createElement('a');
            drill.className = 'tap-y shrink-0 inline-flex items-center font-medium text-brand-700 hover:underline';
            drill.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(shuffleSlugs(kpQs[k].slice(0, 50)).join(','));
            drill.textContent = '连刷 →';
            drill.setAttribute('aria-label', '连刷「' + k + '」错题 ' + kpQs[k].length + ' 题');
            head.appendChild(drill);
          }
          head.appendChild(h('span', 'shrink-0 min-w-[6em] text-right text-muted tabular-nums', counts[k] + ' 题 · ' + pct + '%'));
          var track = h('div', 'mt-1 h-2 overflow-hidden rounded-full bg-slate-100');
          var bar = h('div', 'h-full rounded-full bg-red-400');
          bar.style.width = Math.max(pct, 4) + '%';
          track.appendChild(bar);
          row.appendChild(head); row.appendChild(track);
          box.appendChild(row);
        });
      }
      /* 题型分布：按题型计数 + 连刷，≥2 个题型才显示（与报告题型分析口径一致） */
      var tc = {}; var tord = []; var tQs = {};
      items.forEach(function (q) {
        var t = QTYPE[q.qtype] || '';
        if (!t) return;
        if (!tc[t]) { tc[t] = 0; tord.push(t); tQs[t] = []; }
        tc[t] += 1;
        if (q.slug) tQs[t].push(q.slug);
      });
      if (tord.length >= 2) {
        tord.sort(function (x, y) { return tc[y] - tc[x]; });
        box.appendChild(h('p', 'mt-3 text-[13px] font-medium text-slate-600', '题型分布（最近 ' + items.length + ' 题）'));
        var trow = h('div', 'mt-1.5 flex flex-wrap gap-x-4 gap-y-1 text-[13px] text-muted');
        tord.forEach(function (t) {
          var sp = h('span', 'inline-flex items-baseline gap-1 tabular-nums');
          sp.appendChild(h('span', '', t + ' ' + tc[t] + ' 题'));
          if (tQs[t].length > 0) {
            var da = document.createElement('a');
            da.className = 'tap-y inline-flex items-center font-medium text-brand-700 hover:underline';
            da.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(shuffleSlugs(tQs[t].slice(0, 50)).join(','));
            da.textContent = '连刷 →';
            da.setAttribute('aria-label', '连刷「' + t + '」错题 ' + tQs[t].length + ' 题');
            sp.appendChild(da);
          }
          trow.appendChild(sp);
        });
        box.appendChild(trow);
      }
      var wr = store.read('tiku-wrongr', '{}');
      var rc = {}; var marked = 0;
      allSlugs.forEach(function (s) {
        var code = wr[s];
        if (code && reasonLabel(code)) { rc[code] = (rc[code] || 0) + 1; marked += 1; }
      });
      if (marked > 0) {
        box.appendChild(h('p', 'mt-3 text-[13px] font-medium text-slate-600', '错误原因分布'));
        var rrow = h('div', 'mt-1.5 flex flex-wrap gap-x-4 gap-y-1 text-[13px] text-muted');
        REASONS.forEach(function (r) {
          if (rc[r[0]]) rrow.appendChild(h('span', 'tabular-nums', r[1] + ' ' + rc[r[0]] + ' 题'));
        });
        if (allSlugs.length > marked) rrow.appendChild(h('span', 'tabular-nums', '未标注 ' + (allSlugs.length - marked) + ' 题'));
        box.appendChild(rrow);
      }
      var wkAll = store.read('tiku-wrongk', '{}');
      var stageN = [0, 0, 0];
      allSlugs.forEach(function (s) {
        var st = wkAll['/q/' + s + '/'] || 0;
        stageN[Math.min(st, 2)] += 1;
      });
      box.appendChild(h('p', 'mt-3 text-[13px] font-medium text-slate-600', '复习进度（三轮出师）'));
      var srow = h('div', 'mt-1.5 flex flex-wrap gap-x-4 gap-y-1 text-[13px] text-muted');
      srow.appendChild(h('span', 'tabular-nums', '第 0 轮 ' + stageN[0] + ' 题'));
      srow.appendChild(h('span', 'tabular-nums', '第 1 轮 ' + stageN[1] + ' 题'));
      srow.appendChild(h('span', 'tabular-nums', '第 2 轮 ' + stageN[2] + ' 题'));
      if (stageN[2] > 0) srow.appendChild(h('span', 'tabular-nums text-emerald-700', stageN[2] + ' 题再答对 1 次即出师'));
      var gradN = store.read('tiku-wrongg', '0') || 0;
      if (gradN > 0) srow.appendChild(h('span', 'tabular-nums font-medium text-emerald-700', '累计出师 ' + gradN + ' 题'));
      box.appendChild(srow);
      /* 已出师错题归档：展开懒加载题干，支持回顾连刷 */
      var gl = store.readList('tiku-wronggl');
      if (gl.length > 0) {
        var glStrip = function (pp) { return pp.replace(/^\/q\//, '').replace(/\/$/, ''); };
        var det = document.createElement('details');
        det.className = 'mt-2';
        var sum = document.createElement('summary');
        sum.className = 'cursor-pointer text-[13px] font-medium text-brand-700 hover:underline';
        sum.textContent = '已出师错题 ' + gl.length + ' 题 · 回顾';
        det.appendChild(sum);
        var glWrap = h('div', 'mt-2 space-y-1');
        var glReplay = document.createElement('a');
        glReplay.className = 'inline-block text-[13px] font-medium text-brand-700 hover:underline';
        var glRecent50 = gl.slice(-50).reverse();
        glReplay.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(glRecent50.map(glStrip).join(','));
        glReplay.textContent = '连刷回顾（' + glRecent50.length + ' 题）→';
        glWrap.appendChild(glReplay);
        var glList = h('div', 'space-y-1');
        glWrap.appendChild(glList);
        det.appendChild(glWrap);
        var glLoaded = false;
        det.addEventListener('toggle', function () {
          if (!det.open || glLoaded) return;
          glLoaded = true;
          var recent = gl.slice(-20).reverse();
          var slugs = recent.map(glStrip);
          fetch('/api/questions?slugs=' + encodeURIComponent(slugs.join(',')))
            .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
            .then(function (d) {
              var bySlug = {};
              (d.items || []).forEach(function (it) { bySlug[it.slug] = it; });
              slugs.forEach(function (s) {
                var a = document.createElement('a');
                a.className = 'block truncate text-[13px] text-ink hover:text-brand-700 hover:underline';
                a.href = '/q/' + s + '/';
                a.textContent = (bySlug[s] && bySlug[s].stem) ? bySlug[s].stem : s;
                glList.appendChild(a);
              });
            })
            .catch(function () {
              slugs.forEach(function (s) {
                var a = document.createElement('a');
                a.className = 'block truncate text-[13px] text-ink hover:text-brand-700 hover:underline';
                a.href = '/q/' + s + '/';
                a.textContent = s;
                glList.appendChild(a);
              });
            });
        });
        box.appendChild(det);
      }
      var nowSec = Math.floor(Date.now() / 1000);
      var weeks = [0, 0, 0, 0];
      var any = false;
      Object.keys(wt).forEach(function (p) {
        var age = nowSec - wt[p];
        if (age >= 0 && age < 28 * 86400) { weeks[3 - Math.floor(age / (7 * 86400))] += 1; any = true; }
      });
      if (any) {
        box.appendChild(h('p', 'mt-3 text-[13px] font-medium text-slate-600', '近 4 周新增错题（旧→新）'));
        var max = Math.max.apply(null, weeks);
        var chart = h('div', 'mt-1.5 flex h-14 items-end gap-2');
        weeks.forEach(function (n) {
          var col = h('div', 'flex flex-1 flex-col items-center gap-1');
          var bar = h('div', 'w-full rounded-t ' + (n > 0 ? 'bg-brand-600/70' : 'bg-slate-100'));
          bar.style.height = (n > 0 ? Math.max(Math.round(n / max * 40), 6) : 3) + 'px';
          col.appendChild(bar);
          col.appendChild(h('span', 'text-[11px] text-muted tabular-nums', String(n)));
          chart.appendChild(col);
        });
        box.appendChild(chart);
      }
      box.hidden = false;
    }
    /* 我的笔记：最近更新在前，60 条/批「加载更早」，关键词搜索过滤已加载卡片 */
    function fillNotes() {
      var listEl = document.getElementById('note-list'); if (!listEl) return;
      var notes = readNotes();
      var slugs = Object.keys(notes).filter(function (s) { return notes[s] && notes[s].t; });
      slugs.sort(function (x, y) { return (notes[y].u || 0) - (notes[x].u || 0); });
      if (slugs.length === 0) return;
      var BATCH = 60;
      var shown = 0;
      var moreBtn = null;
      var input = document.getElementById('note-search');
      var msg = document.getElementById('note-search-msg');
      var wrapEl = document.getElementById('note-search-wrap');
      function query() { return input ? input.value.trim().toLowerCase() : ''; }
      function cards() { return Array.prototype.slice.call(listEl.querySelectorAll('div[data-note-slug]')); }
      function applySearch() {
        var q = query();
        var hit = 0;
        cards().forEach(function (w) {
          var show = !q || (w.dataset.noteText || '').indexOf(q) !== -1 || (w.dataset.noteStem || '').indexOf(q) !== -1;
          w.hidden = !show;
          if (show) hit += 1;
        });
        if (msg) {
          var left = slugs.length - shown;
          msg.textContent = q ? ('命中 ' + hit + ' 条' + (left > 0 ? '（还有 ' + left + ' 条更早笔记未加载）' : '')) : '';
        }
      }
      function updateMore() {
        var left = slugs.length - shown;
        if (left <= 0) {
          if (moreBtn) { moreBtn.remove(); moreBtn = null; }
          return;
        }
        if (!moreBtn) {
          moreBtn = document.createElement('button');
          moreBtn.type = 'button';
          moreBtn.className = 'mt-3 inline-flex h-10 items-center rounded-lg border border-line bg-white px-4 text-sm font-medium text-brand-700 hover:bg-brand-50';
          moreBtn.addEventListener('click', function () { loadBatch(); });
          listEl.appendChild(moreBtn);
        }
        moreBtn.textContent = '加载更早的笔记（还有 ' + left + ' 条）';
        moreBtn.disabled = false;
      }
      function loadBatch() {
        var next = slugs.slice(shown, shown + BATCH);
        if (next.length === 0) return;
        if (moreBtn) moreBtn.disabled = true;
        var first = shown === 0;
        var req = fetch('/api/questions?slugs=' + encodeURIComponent(next.join(',')))
          .then(function (r) { return r.json(); })
          .then(function (d) {
            shown += next.length;
            var byS = {}; (d.items || []).forEach(function (q) { byS[q.slug] = q; });
            var any = false;
            next.forEach(function (s) {
              var n = notes[s];
              var wrap = document.createElement('div');
              wrap.className = 'relative rounded-xl border border-line bg-white p-4 shadow-sm';
              wrap.dataset.noteSlug = s;
              wrap.dataset.noteText = (n.t || '').toLowerCase();
              wrap.dataset.noteStem = (byS[s] ? byS[s].stem : s).toLowerCase();
              var a = document.createElement('a');
              a.href = '/q/' + s + '/';
              a.className = 'block pr-12 text-[15px] font-medium leading-snug hover:text-brand-700';
              a.textContent = byS[s] ? byS[s].stem : s;
              wrap.appendChild(a);
              var body = document.createElement('p');
              body.className = 'mt-2 whitespace-pre-wrap pr-12 text-sm leading-relaxed text-slate-600';
              body.textContent = n.t.length > 160 ? n.t.slice(0, 160) + '…' : n.t;
              wrap.appendChild(body);
              var time = document.createElement('p');
              time.className = 'mt-2 text-[12px] text-muted';
              time.textContent = '更新于 ' + localDay(new Date((n.u || 0) * 1000));
              wrap.appendChild(time);
              var del = document.createElement('button');
              del.type = 'button';
              del.className = 'absolute right-2 top-2 grid size-10 place-items-center rounded-lg text-muted hover:bg-red-50 hover:text-red-600';
              del.setAttribute('aria-label', '删除这条笔记');
              del.innerHTML = '<svg class="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 7h12M9 7V5h6v2m-8 0 1 12h8l1-12"/></svg>';
              del.addEventListener('click', function () {
                if (!window.confirm('删除这条笔记？')) return;
                saveNote(s, '');
                wrap.remove();
                applySearch();
                if (cards().length === 0 && !moreBtn) { document.getElementById('note-empty').style.display = ''; }
              });
              wrap.appendChild(del);
              if (moreBtn) listEl.insertBefore(wrap, moreBtn); else listEl.appendChild(wrap);
              any = true;
            });
            updateMore();
            if (any) { document.getElementById('note-empty').style.display = 'none'; }
            applySearch();
          }).catch(function () {
            if (moreBtn) moreBtn.disabled = false;
          });
        if (first) trackFill(req);
      }
      if (wrapEl) wrapEl.hidden = false;
      if (input) input.addEventListener('input', applySearch);
      loadBatch();
    }
    /* 练习历史：交卷记录倒序展示，可一键重刷本卷 */
    function fillHist() {
      var listEl = document.getElementById('hist-list'); if (!listEl) return;
      var hist = store.read('tiku-hist', '[]');
      if (!Array.isArray(hist)) hist = [];
      hist = hist.filter(function (h) { return h && h.n > 0 && Array.isArray(h.q); });
      if (hist.length === 0) return;
      document.getElementById('hist-empty').style.display = 'none';
      var HBATCH = 20;
      var hShown = 0;
      var hMore = null;
      function histType(h) {
        var s = h.s || '';
        if (s.indexOf('每日一练') === 0) return 'daily';
        if (/每周模考|全真模拟卷|固定卷|随机卷|随机全卷|限时模考/.test(s)) return 'mock';
        if (/连刷|自选组卷|智能练习/.test(s)) return 'drill';
        return 'other';
      }
      var cur = hist;
      function renderHist(h) {
        var pct = Math.round((h.ok || 0) / h.n * 100);
        var wrap = document.createElement('div');
        wrap.className = 'flex flex-wrap items-center gap-x-4 gap-y-2 rounded-xl border border-line bg-white p-4 shadow-sm';
        var left = document.createElement('div');
        left.className = 'min-w-0 flex-1 basis-full sm:basis-0';
        var name = document.createElement('p');
        name.className = 'truncate text-[15px] font-medium';
        name.textContent = h.s || '练习';
        left.appendChild(name);
        var m = document.createElement('p');
        m.className = 'mt-1 text-[13px] text-muted tabular-nums';
        m.textContent = localDay(new Date((h.d || 0) * 1000)) + ' · 用时 ' + Math.floor((h.u || 0) / 60) + ' 分 ' + ((h.u || 0) % 60) + ' 秒' + (h.un > 0 ? ' · 未答 ' + h.un : '');
        left.appendChild(m);
        wrap.appendChild(left);
        var score = document.createElement('p');
        score.className = 'shrink-0 text-sm font-semibold tabular-nums ' + (pct >= 80 ? 'text-emerald-700' : pct >= 50 ? 'text-amber-700' : 'text-red-600');
        score.textContent = (h.ok || 0) + '/' + h.n + ' · ' + pct + '%';
        wrap.appendChild(score);
        var redo = document.createElement('a');
        redo.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(h.q.slice(0, 150).join(','));
        redo.className = 'inline-flex h-10 shrink-0 items-center rounded-lg border border-line px-3.5 text-sm font-medium text-brand-700 hover:bg-brand-50';
        redo.textContent = '重刷本卷 →';
        wrap.appendChild(redo);
        if (Array.isArray(h.w) && h.w.length > 0) {
          var redoW = document.createElement('a');
          redoW.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(h.w.slice(0, 150).join(','));
          redoW.className = 'inline-flex h-10 shrink-0 items-center rounded-lg border border-red-200 px-3.5 text-sm font-medium text-red-600 hover:bg-red-50';
          redoW.textContent = (h.un > 0 ? '重刷错题+未答（' : '重刷错题（') + h.w.length + '）→';
          wrap.appendChild(redoW);
        }
        /* 详情：展开逐题对错网格（懒渲染），R59 前旧记录无 w 时中性格 */
        var detBtn = document.createElement('button');
        detBtn.type = 'button';
        detBtn.className = 'inline-flex h-10 shrink-0 items-center rounded-lg border border-line px-3.5 text-sm font-medium text-muted hover:bg-slate-50';
        detBtn.textContent = '详情 ▾';
        detBtn.setAttribute('aria-expanded', 'false');
        wrap.appendChild(detBtn);
        var det = document.createElement('div');
        det.className = 'mt-1 w-full basis-full';
        det.hidden = true;
        wrap.appendChild(det);
        detBtn.addEventListener('click', function () {
          if (det.hidden && !det.firstChild) {
            var hasW = Array.isArray(h.w);
            var grid = document.createElement('div');
            grid.className = 'grid grid-cols-8 gap-2 sm:grid-cols-10';
            h.q.slice(0, 150).forEach(function (slug, i) {
              var isWrong = hasW && h.w.indexOf(slug) >= 0;
              var a = document.createElement('a');
              a.href = '/q/' + slug + '/';
              a.className = 'grid h-10 place-items-center rounded-lg text-sm font-medium tabular-nums ' +
                (hasW ? (isWrong ? 'bg-red-600 text-white' : 'bg-emerald-700 text-white') : 'border border-line bg-white text-slate-600 hover:bg-slate-50');
              a.textContent = String(i + 1);
              a.setAttribute('aria-label', '第 ' + (i + 1) + ' 题' + (hasW ? (isWrong ? '，答错' : '，答对') : '') + '，点击查看题目');
              grid.appendChild(a);
            });
            det.appendChild(grid);
          }
          det.hidden = !det.hidden;
          detBtn.textContent = det.hidden ? '详情 ▾' : '详情 ▴';
          detBtn.setAttribute('aria-expanded', det.hidden ? 'false' : 'true');
        });
        if (hMore) listEl.insertBefore(wrap, hMore);
        else listEl.appendChild(wrap);
      }
      function histBatch() {
        cur.slice(hShown, hShown + HBATCH).forEach(renderHist);
        hShown = Math.min(hShown + HBATCH, cur.length);
        var left = cur.length - hShown;
        if (left <= 0) {
          if (hMore) { hMore.remove(); hMore = null; }
          return;
        }
        if (!hMore) {
          hMore = document.createElement('button');
          hMore.type = 'button';
          hMore.className = 'mt-3 inline-flex h-10 items-center rounded-lg border border-line bg-white px-4 text-sm font-medium text-brand-700 hover:bg-brand-50';
          hMore.addEventListener('click', histBatch);
          listEl.appendChild(hMore);
        }
        hMore.textContent = '加载更早的练习记录（还有 ' + left + ' 条）';
      }
      /* 类型 chips：全部/每日一练/模考/连刷组卷（单一类型不渲染） */
      var TYPE_LABEL = { daily: '每日一练', mock: '模考', drill: '连刷组卷', other: '其他' };
      var counts = {};
      hist.forEach(function (h) { var t = histType(h); counts[t] = (counts[t] || 0) + 1; });
      var types = Object.keys(counts);
      if (types.length > 1) {
        var bar = document.createElement('div');
        bar.className = 'mb-3 flex flex-wrap gap-2';
        var order = ['all', 'daily', 'mock', 'drill', 'other'];
        var btns = {};
        function setActive(t) {
          Object.keys(btns).forEach(function (k) {
            var on = k === t;
            btns[k].className = 'inline-flex h-10 md:h-9 items-center rounded-full border px-3.5 text-[13px] font-medium ' +
              (on ? 'border-brand-700 bg-brand-700 text-white' : 'border-line bg-white text-slate-600 hover:bg-slate-50');
            btns[k].setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }
        order.forEach(function (t) {
          if (t !== 'all' && !counts[t]) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = (t === 'all' ? '全部' : TYPE_LABEL[t]) + ' (' + (t === 'all' ? hist.length : counts[t]) + ')';
          b.addEventListener('click', function () {
            cur = t === 'all' ? hist : hist.filter(function (h) { return histType(h) === t; });
            hShown = 0;
            if (hMore) { hMore.remove(); hMore = null; }
            listEl.textContent = '';
            setActive(t);
            histBatch();
          });
          btns[t] = b;
          bar.appendChild(b);
        });
        setActive('all');
        listEl.parentNode.insertBefore(bar, listEl);
      }
      histBatch();
    }
    fillHist();
    /* 错题/收藏一键连刷：取最近 20 条进操作台整卷重刷 */
    function refreshLink(id, slugs) {
      var a = document.getElementById(id); if (!a || slugs.length === 0) return;
      var recent = slugs.slice(-20).reverse();
      if (id === 'wrong-refresh') recent = shuffleSlugs(recent);
      a.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(recent.join(','));
      a.textContent += slugs.length > 20 ? '（最近 20 题）' : '（' + slugs.length + ' 题）';
      a.hidden = false;
    }
    refreshLink('wrong-refresh', wrong);
    refreshLink('fav-refresh', favs);
    /* 高频错题连刷：错 ≥2 次且仍在错题本的题，按次数降序取前 20 */
    (function () {
      var a = document.getElementById('wrong-hifreq'); if (!a) return;
      var wn = store.read('tiku-wrongn', '{}');
      var hi = wrong.filter(function (s) { return (wn[s] || 0) >= 2; })
        .sort(function (x, y) { return (wn[y] || 0) - (wn[x] || 0); }).slice(0, 20);
      if (hi.length === 0) return;
      a.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(hi.join(','));
      a.textContent = '高频错题连刷（' + hi.length + ' 题）→';
      a.hidden = false;
    })();
    fillNotes();
    /* 我的讨论：tiku-ctok 本机评论 id 聚合，附题干链接与回复数 */
    function fillMyComments() {
      var listEl = document.getElementById('mycmt-list'); if (!listEl) return;
      var tok; try { tok = JSON.parse(localStorage.getItem('tiku-ctok') || '{}'); } catch (_) { tok = {}; }
      if (!tok || typeof tok !== 'object') tok = {};
      var ids = Object.keys(tok).filter(function (k) { return /^\d+$/.test(k); });
      if (ids.length === 0) return;
      var seen = store.read('tiku-cseen', '{}');
      if (!seen || typeof seen !== 'object') seen = {};
      ids.sort(function (a, b) { return b - a; });
      var shown = ids.slice(0, 50);
      trackFill(fetch('/api/my-comments?ids=' + shown.join(','))
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .then(function (d) {
          var items = (d && d.items) || [];
          if (items.length === 0) return;
          document.getElementById('mycmt-empty').style.display = 'none';
          items.forEach(function (it) {
            var wrap = document.createElement('div');
            wrap.className = 'rounded-xl border border-line bg-white p-4 shadow-sm';
            var a = document.createElement('a');
            a.href = '/q/' + it.slug + '/';
            a.className = 'block text-[15px] font-medium leading-snug hover:text-brand-700';
            a.textContent = it.stem && it.stem.length > 80 ? it.stem.slice(0, 80) + '…' : (it.stem || it.slug);
            wrap.appendChild(a);
            var body = document.createElement('p');
            body.className = 'mt-2 text-sm leading-relaxed text-slate-600';
            body.textContent = (it.pid > 0 ? '回复：' : '') + (it.content.length > 120 ? it.content.slice(0, 120) + '…' : it.content);
            wrap.appendChild(body);
            var meta = document.createElement('p');
            meta.className = 'mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[12px] text-muted tabular-nums';
            var t1 = document.createElement('span');
            t1.textContent = localDay(new Date((it.t || 0) * 1000)) + ' · 有用 ' + (it.likes || 0);
            meta.appendChild(t1);
            if (it.pid === 0) {
              var rep = document.createElement('span');
              if ((it.replies || 0) > 0) {
                rep.className = 'rounded-full bg-amber-100 px-2 py-0.5 font-medium text-amber-800';
                rep.textContent = it.replies + ' 条回复 →';
              } else {
                rep.textContent = '暂无回复';
              }
              meta.appendChild(rep);
              if ((it.replies || 0) > (seen[it.id] || 0)) {
                var nw = document.createElement('span');
                nw.className = 'rounded-full bg-red-600 px-2 py-0.5 font-medium text-white';
                nw.textContent = '新';
                meta.appendChild(nw);
              }
            }
            wrap.appendChild(meta);
            listEl.appendChild(wrap);
          });
          /* 访问即已读：回复数写回基线，清除全站红点标志 */
          items.forEach(function (it) { if (it.pid === 0) seen[it.id] = it.replies || 0; });
          store.write('tiku-cseen', seen);
          try { localStorage.removeItem('tiku-cnew'); } catch (_) { /* noop */ }
        }).catch(function () { /* noop */ }));
    }
    fillMyComments();
    /* 知识点掌握度：最近 100 条已做题 × 错题本，客户端近似聚合，薄弱在前 */
    function fillMastery() {
      if (done.length < 5) return;
      var recent = done.slice(-100);
      var wrongSet = {}; wrong.forEach(function (s) { wrongSet[s] = 1; });
      trackFill(fetch('/api/questions?slugs=' + encodeURIComponent(recent.join(',')))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var agg = {}; var order = []; var qKps = {};
          (d.items || []).forEach(function (q) {
            var names = (q.kp_names || '').split('|').filter(Boolean);
            var slugsArr = (q.kp_slugs || '').split('|').filter(Boolean);
            qKps[q.slug] = names;
            names.forEach(function (nm, ni) {
              if (!agg[nm]) { agg[nm] = { ok: 0, total: 0, href: '', es: '', sn: '' }; order.push(nm); }
              agg[nm].total++; if (!wrongSet[q.slug]) agg[nm].ok++;
              if (!agg[nm].href && slugsArr[ni] && q.exam_slug && q.subject_slug) {
                agg[nm].href = '/practice/?mode=kp&exam=' + encodeURIComponent(q.exam_slug) + '&subject=' + encodeURIComponent(q.subject_slug) + '&kp=' + encodeURIComponent(slugsArr[ni]);
                agg[nm].es = q.exam_slug + '/' + q.subject_slug;
                agg[nm].sn = q.subject_name || '';
              }
            });
          });
          order = order.filter(function (nm) { return agg[nm].total >= 2; });
          if (order.length === 0) return;
          /* 二级题型「父名·子名」与父同现时挂为父行下的子行（父按正确率排，子在父内按正确率排），不当两个考点重复列（docs/plan-r528） */
          var parentOf = {};
          order.forEach(function (nm) {
            order.forEach(function (o) { if (o !== nm && nm.indexOf(o + '·') === 0 && (!parentOf[nm] || o.length > parentOf[nm].length)) parentOf[nm] = o; });
          });
          var byAcc = function (a2, b2) { return agg[a2].ok / agg[a2].total - agg[b2].ok / agg[b2].total; };
          var tops = order.filter(function (nm) { return !parentOf[nm]; }).sort(byAcc);
          order = [];
          tops.forEach(function (p) {
            order.push(p);
            Object.keys(parentOf).filter(function (c) { return parentOf[c] === p; }).sort(byAcc).forEach(function (c) { order.push(c); });
          });
          var list = document.getElementById('mastery-list'); if (!list) return;
          /* 薄弱阈值与科目页/考点页一致（样本为最近 100 条 done、按考点名聚合，科目页按 slug 取科目全部 done）；智能练习入口指向薄弱考点最多的科目（无薄弱则取所有考点最多的科目） */
          function isWeak(nm) { return agg[nm].total >= WEAK_MIN_DONE && agg[nm].ok / agg[nm].total < WEAK_ACC; }
          /* 近期错过：样本未达薄弱阈值但已有错题（≥WEAK_MIN_DONE 的行不标，避免 8/10 也被标） */
          function isMissed(nm) { return agg[nm].total < WEAK_MIN_DONE && agg[nm].ok < agg[nm].total; }
          function topEs(names) {
            var cnt = {}; var best = '';
            names.forEach(function (nm) {
              var k = agg[nm].es; if (!k) return;
              cnt[k] = (cnt[k] || 0) + 1;
              if (!best || cnt[k] > cnt[best]) best = k;
            });
            return best;
          }
          var smartEs = topEs(order.filter(isWeak)) || topEs(order.filter(isMissed)) || topEs(order);
          var smartA = document.getElementById('mastery-smart');
          if (smartA && smartEs) {
            var esP = smartEs.split('/');
            smartA.href = smartPracticeHref(esP[0], esP[1]);
            smartA.hidden = false;
          }
          var headByName = {};
          var shown = order.slice(0, 12);
          /* 跨考试/科目混排时考点名后追加科目名，单科目态不加 */
          var esSet = {};
          shown.forEach(function (nm) { if (agg[nm].es) esSet[agg[nm].es] = 1; });
          var multiEs = Object.keys(esSet).length > 1;
          shown.forEach(function (nm) {
            var pct = Math.round(agg[nm].ok / agg[nm].total * 100);
            var par = parentOf[nm] || '';
            var row = document.createElement('div'); if (par) row.className = 'pl-3';
            var head = document.createElement('div'); head.className = 'flex items-baseline gap-2 text-[13px]';
            /* 375 行宽≈309px：徽标/连刷/计数/领先 均 shrink-0 靠右成列，考点名 flex-1 吃满余宽、保底 3em 不被挤成单字 */
            var label = document.createElement('span'); label.className = 'min-w-[3em] flex-1 truncate text-slate-700';
            if (par) {
              var srP = document.createElement('span'); srP.className = 'sr-only'; srP.textContent = par + '·';
              var mark = document.createElement('span'); mark.className = 'text-muted'; mark.textContent = '└ ';
              label.appendChild(srP); label.appendChild(mark); label.appendChild(document.createTextNode(nm.slice(par.length + 1)));
            } else label.textContent = nm;
            var subLine = null;
            if (multiEs && agg[nm].sn) {
              /* 科目全名较长：≥sm 跟在考点名后；<sm 双徽标行 label 仅余 ~55px，改为整行宽的第二行 */
              var sn = document.createElement('span'); sn.className = 'ml-1 hidden text-[11px] text-muted sm:inline'; sn.textContent = agg[nm].sn;
              label.appendChild(sn);
              subLine = document.createElement('div'); subLine.className = 'truncate text-[11px] text-muted sm:hidden'; subLine.textContent = agg[nm].sn;
            }
            var val = document.createElement('span'); val.className = 'shrink-0 sm:min-w-[6em] text-right text-muted tabular-nums'; val.textContent = agg[nm].ok + '/' + agg[nm].total + ' · ' + pct + '%';
            head.appendChild(label);
            if (isWeak(nm)) {
              var wk = document.createElement('span');
              wk.className = 'shrink-0 inline-block whitespace-nowrap rounded-full bg-rose-100 px-1.5 py-0.5 text-[11px] font-medium text-rose-700';
              wk.textContent = '薄弱考点';
              head.appendChild(wk);
            } else if (isMissed(nm)) {
              var ms = document.createElement('span');
              ms.className = 'shrink-0 inline-block whitespace-nowrap rounded-full bg-amber-100 px-1.5 py-0.5 text-[11px] font-medium text-amber-800';
              ms.textContent = '近期错过';
              head.appendChild(ms);
            }
            if (agg[nm].href) {
              var go = document.createElement('a');
              go.className = 'shrink-0 -my-2.5 inline-flex min-h-10 items-center px-1.5 text-[13px] font-medium text-brand-700 hover:underline';
              go.href = agg[nm].href; go.textContent = '连刷 →';
              go.setAttribute('aria-label', '连刷「' + nm + '」');
              head.appendChild(go);
            }
            head.appendChild(val);
            headByName[nm] = { head: head, pct: pct };
            var track = document.createElement('div'); track.className = 'mt-1 h-2 overflow-hidden rounded-full bg-slate-100';
            var bar = document.createElement('div');
            bar.className = 'h-full rounded-full ' + (pct >= 80 ? 'bg-emerald-500' : pct >= 50 ? 'bg-amber-400' : 'bg-red-400');
            bar.style.width = pct + '%';
            track.appendChild(bar);
            row.appendChild(head); if (subLine) row.appendChild(subLine); row.appendChild(track); list.appendChild(row);
          });
          document.getElementById('mastery').classList.remove('hidden');
          injectMasteryQstats(recent, qKps, headByName);
        }).catch(function () { /* noop */ }));
    }
    /* 掌握度全站参照：同题集按考点聚合 /api/qstats，attempts≥5 的题 ≥2 道才显示 */
    function injectMasteryQstats(recent, qKps, headByName) {
      var reqs = [];
      for (var i = 0; i < recent.length; i += 20) {
        reqs.push(fetch('/api/qstats?slugs=' + encodeURIComponent(recent.slice(i, i + 20).join(',')))
          .then(function (r) { return r.json(); })
          .then(function (d) { return d.items || []; })
          .catch(function () { return []; }));
      }
      Promise.all(reqs).then(function (parts) {
        var g = {};
        parts.forEach(function (items) {
          items.forEach(function (it) {
            if ((it.attempts || 0) < 5) return;
            (qKps[it.slug] || []).forEach(function (nm) {
              if (!g[nm]) g[nm] = { att: 0, cor: 0, n: 0 };
              g[nm].att += it.attempts; g[nm].cor += it.correct; g[nm].n += 1;
            });
          });
        });
        Object.keys(headByName).forEach(function (nm) {
          var s = g[nm];
          if (!s || s.n < 2 || s.att === 0) return;
          var gp = Math.round(s.cor / s.att * 100);
          var sp = document.createElement('span');
          /* 375 只保留领先/落后标签，全站百分比 ≥sm 才显示，给考点名让位 */
          sp.className = 'shrink-0 text-[12px] text-muted tabular-nums max-sm:hidden';
          sp.textContent = '全站 ' + gp + '%';
          headByName[nm].head.appendChild(sp);
          var diff = headByName[nm].pct - gp;
          if (diff >= 10 || diff <= -10) {
            var tag = document.createElement('span');
            tag.className = 'shrink-0 rounded-full px-1.5 py-0.5 text-[11px] font-medium ' +
              (diff >= 10 ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700');
            tag.textContent = diff >= 10 ? '领先' : '落后';
            headByName[nm].head.appendChild(tag);
          }
        });
      });
    }
    /* 错题间隔复习：距最后答错/复习 ≥ 当前轮次间隔（1/3/7 天）→「今日待复习」横幅 */
    (function fillWrongDue() {
      var box = document.getElementById('wrong-due'); if (!box) return;
      var due = wrongDue();
      if (due.length === 0) return;
      var slugs = shuffleSlugs(due.map(toSlug).filter(Boolean).slice(0, 20));
      if (slugs.length === 0) return;
      var row = document.createElement('div');
      row.className = 'flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-300 bg-amber-50 p-3.5';
      var txt = document.createElement('p');
      txt.className = 'text-sm text-amber-800';
      txt.textContent = '今日待复习 ' + due.length + ' 题：按 1/3/7 天间隔回炉，三轮答对出师移出';
      var go = document.createElement('a');
      go.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(slugs.join(',')) + '&review=1';
      go.className = 'inline-flex h-10 items-center rounded-lg bg-amber-700 px-3.5 text-sm font-medium text-white hover:bg-amber-800';
      go.textContent = '开始复习' + (due.length > 20 ? '（先刷 20 题）' : '') + ' →';
      row.appendChild(txt); row.appendChild(go);
      box.appendChild(row);
      box.hidden = false;
    })();
    fillMastery();
    fillGrouped(wrong, { listId: 'wrong-list', emptyId: 'wrong-empty', key: 'tiku-wrong', badges: true, insight: true, reasons: true, chips: { kp: 'wrong-kp-chips', subj: 'wrong-subj-chips', diff: 'wrong-diff-chips', qtype: 'wrong-qtype-chips', reason: 'wrong-reason-chips', noun: '错题', print: 'wrong-print' } });
    fillGrouped(favs, { listId: 'fav-list', emptyId: 'fav-empty', key: 'tiku-fav', badges: false, chips: { kp: 'fav-kp-chips', subj: 'fav-subj-chips', diff: 'fav-diff-chips', qtype: 'fav-qtype-chips', noun: '收藏', print: 'fav-print' } });
  }

  /* ---------- 学习数据快照与合并（云同步与导出/导入共用同一契约） ---------- */
  var SYNC_KEYS = ['tiku-done', 'tiku-wrong', 'tiku-fav'];
  function readNick() {
    try { return String(localStorage.getItem('tiku-nick') || '').slice(0, 20); } catch (_) { return ''; }
  }
  /* 做题偏好键白名单：快照存原始字符串（含 tiku-hidedone 的非 JSON '1'），导入仅在本机未显式设置时采用 */
  var PREF_KEYS = ['tiku-exam', 'tiku-goal', 'tiku-n', 'tiku-font', 'tiku-auto', 'tiku-browse', 'tiku-defer', 'tiku-shufopt', 'tiku-dark', 'tiku-hidedone'];
  function readPrefs() {
    var out = {};
    PREF_KEYS.forEach(function (k) {
      try { var v = localStorage.getItem(k); if (v !== null && v.length <= 40) { out[k] = v; } } catch (_) { /* noop */ }
    });
    return out;
  }
  function dataSnapshot() {
    var p = { app: 'tiku-sync', version: 1, lists: {}, stats: store.read('tiku-stats', '{"a":0,"c":0}'), days: store.read('tiku-days', '{}'), dayok: store.read('tiku-dayok', '{}'), notes: readNotes(), hist: store.read('tiku-hist', '[]'), wrongn: store.read('tiku-wrongn', '{}'), pick: store.read('tiku-pick', '{}'), wrongt: store.read('tiku-wrongt', '{}'), wrongk: store.read('tiku-wrongk', '{}'), wrongr: store.read('tiku-wrongr', '{}'), wrongg: store.read('tiku-wrongg', '0'), wronggl: store.readList('tiku-wronggl'), combo: store.read('tiku-combo', '0'), mins: store.read('tiku-mins', '{}'), plan: store.read('tiku-plan', 'null'), kpfav: store.readList('tiku-kpfav'), view: store.readList('tiku-view'), ai: store.readList('tiku-ai'), air: store.readList('tiku-air'), fbk: store.readList('tiku-fbk'), ctok: store.read('tiku-ctok', '{}'), clike: store.readList('tiku-clike'), crep: store.readList('tiku-crep'), kw: store.readList('tiku-kw'), cseen: store.read('tiku-cseen', '{}'), nick: readNick(), rank: store.read('tiku-rank', '{}'), prefs: readPrefs() };
    SYNC_KEYS.forEach(function (k) { p.lists[k] = store.readList(k); });
    return JSON.stringify(p);
  }
  /* 暂存写：合并期间所有读写走暂存层（读到本次已暂存的值），全部算完才 commit 落 localStorage；
     中途任何异常都不落盘，调用方「本地数据未改动」文案才成立 */
  function stagedStore() {
    var staged = {}; var has = {};
    function raw(k) {
      if (has[k]) return staged[k];
      try { return localStorage.getItem(k); } catch (_) { return null; }
    }
    var s = {
      raw: raw,
      writeRaw: function (k, v) { staged[k] = String(v); has[k] = 1; },
      read: function (k, def) {
        var v = raw(k);
        try { return JSON.parse(v === null ? def : v); } catch (_) { return JSON.parse(def); }
      },
      readList: function (k) { return s.read(k, '[]'); },
      write: function (k, v) { s.writeRaw(k, JSON.stringify(v)); },
      commit: function () {
        Object.keys(has).forEach(function (k) { try { localStorage.setItem(k, staged[k]); } catch (_) { /* noop */ } });
      }
    };
    return s;
  }
  /* 合并语义：列表取并集；总计取作答数更大的一份；每日条数逐日取最大，不覆盖本机已有 */
  function dataMerge(p) {
      var store = stagedStore();
      var added = 0;
      SYNC_KEYS.forEach(function (k) {
        var cur = store.readList(k); var seen = {};
        cur.forEach(function (v) { seen[v] = 1; });
        var inc0 = (p.lists || {})[k];
        (Array.isArray(inc0) ? inc0 : []).forEach(function (v) {
          if (typeof v === 'string' && !seen[v]) { cur.push(v); seen[v] = 1; added += 1; }
        });
        store.write(k, cur);
      });
      var st = store.read('tiku-stats', '{"a":0,"c":0}');
      if (p.stats && (p.stats.a || 0) > (st.a || 0)) { store.write('tiku-stats', p.stats); }
      var days = store.read('tiku-days', '{}');
      Object.keys(p.days || {}).forEach(function (k) { if ((p.days[k] || 0) > (days[k] || 0)) { days[k] = p.days[k]; } });
      store.write('tiku-days', days);
      /* 每日答对数：逐日取最大（与 days 同语义）；旧 payload 无 dayok 字段则跳过 */
      var dok = store.read('tiku-dayok', '{}');
      Object.keys(p.dayok || {}).forEach(function (k) {
        var ov = (p.dayok || {})[k];
        if (typeof ov === 'number' && ov >= 0 && (!(k in dok) || ov > dok[k])) { dok[k] = ov; }
      });
      store.write('tiku-dayok', dok);
      /* 每日练习秒数：逐日取最大；旧 payload 无 mins 字段则跳过 */
      var mm = store.read('tiku-mins', '{}');
      Object.keys(p.mins || {}).forEach(function (k) {
        var mv = (p.mins || {})[k];
        if (typeof mv === 'number' && mv > (mm[k] || 0)) { mm[k] = mv; }
      });
      store.write('tiku-mins', mm);
      /* 笔记：逐题按更新时间新者胜；旧 payload 无 notes 字段则跳过 */
      var notes = store.read(NOTE_KEY, '{}');
      if (!notes || typeof notes !== 'object' || Array.isArray(notes)) notes = {};
      Object.keys(p.notes || {}).forEach(function (s) {
        var inc = (p.notes || {})[s];
        if (!inc || typeof inc.t !== 'string' || !inc.t) { return; }
        var curN = notes[s];
        if (!curN || (inc.u || 0) > (curN.u || 0)) {
          notes[s] = { t: String(inc.t).slice(0, 1000), u: inc.u || 0 };
          added += 1;
        }
      });
      store.write(NOTE_KEY, capNotes(notes));
      /* 练习历史：按 交卷时间+卷名 去重取并集，倒序截断 50；旧 payload 无 hist 字段则跳过 */
      var hist = store.read('tiku-hist', '[]');
      if (!Array.isArray(hist)) hist = [];
      var histSeen = {};
      hist.forEach(function (h) { if (h) { histSeen[(h.d || 0) + '|' + (h.s || '')] = 1; } });
      (Array.isArray(p.hist) ? p.hist : []).forEach(function (h) {
        if (!h || typeof h.d !== 'number' || typeof h.s !== 'string' || typeof h.n !== 'number' || !(h.n > 0) || typeof h.ok !== 'number' || !Array.isArray(h.q)) { return; }
        var key = h.d + '|' + h.s;
        if (histSeen[key]) { return; }
        histSeen[key] = 1;
        var hh = { d: h.d, s: h.s.slice(0, 80), n: h.n, ok: h.ok, q: h.q.filter(function (v) { return typeof v === 'string'; }).slice(0, 150) };
        if (typeof h.m === 'string') hh.m = h.m;
        if (typeof h.un === 'number') hh.un = h.un;
        if (typeof h.u === 'number') hh.u = h.u;
        if (Array.isArray(h.w)) hh.w = h.w.filter(function (v) { return typeof v === 'string'; }).slice(0, 150);
        hist.push(hh); added += 1;
      });
      hist.sort(function (x, y) { return (y.d || 0) - (x.d || 0); });
      if (hist.length > 50) hist.length = 50;
      store.write('tiku-hist', hist);
      /* 错题次数：逐 slug 取较大值；旧 payload 无 wrongn 字段则跳过 */
      var wn = store.read('tiku-wrongn', '{}');
      Object.keys(p.wrongn || {}).forEach(function (s) {
        var v = (p.wrongn || {})[s];
        if (typeof v === 'number' && v > (wn[s] || 0)) { wn[s] = v; }
      });
      store.write('tiku-wrongn', wn);
      /* 上次作答：本地已有不覆盖（无时间戳，本机最新优先）；旧 payload 无 pick 字段则跳过 */
      var pk = store.read('tiku-pick', '{}');
      if (!pk || typeof pk !== 'object' || Array.isArray(pk)) pk = {};
      Object.keys(p.pick || {}).forEach(function (s) {
        var pv = (p.pick || {})[s];
        if (!pk[s] && /^[A-H]{1,8}$/.test(pv)) { pk[s] = pv; }
      });
      store.write('tiku-pick', pk);
      /* 最后答错时间：逐键取较大时间戳；旧 payload 无 wrongt 字段则跳过 */
      var wt = store.read('tiku-wrongt', '{}');
      Object.keys(p.wrongt || {}).forEach(function (s) {
        var tv = (p.wrongt || {})[s];
        if (typeof tv === 'number' && tv > (wt[s] || 0)) { wt[s] = tv; }
      });
      store.write('tiku-wrongt', wt);
      /* 复习轮次：逐键取较大轮次；旧 payload 无 wrongk 字段则跳过 */
      var wkm = store.read('tiku-wrongk', '{}');
      Object.keys(p.wrongk || {}).forEach(function (s) {
        var kv = (p.wrongk || {})[s];
        if (typeof kv === 'number' && kv > (wkm[s] || 0)) { wkm[s] = Math.min(2, kv); }
      });
      store.write('tiku-wrongk', wkm);
      /* 错题原因：逐 slug 合并，本地已有标注优先；旧 payload 无 wrongr 字段则跳过 */
      var wr2 = store.read('tiku-wrongr', '{}');
      Object.keys(p.wrongr || {}).forEach(function (s) {
        var rv = (p.wrongr || {})[s];
        if (typeof rv === 'string' && !wr2[s]) { wr2[s] = rv; }
      });
      store.write('tiku-wrongr', wr2);
      /* 出师累计：取较大值（计数只增）；旧 payload 无 wrongg 字段则跳过 */
      if (typeof p.wrongg === 'number' && p.wrongg > (store.read('tiku-wrongg', '0') || 0)) { store.write('tiku-wrongg', p.wrongg); }
      /* 出师归档：取并集去重，仍在错题本的路径不算已出师，cap 200；旧 payload 无 wronggl 字段则跳过 */
      var glm = store.readList('tiku-wronggl');
      var glSeen = {};
      glm.forEach(function (v) { glSeen[v] = 1; });
      (Array.isArray(p.wronggl) ? p.wronggl : []).forEach(function (v) {
        if (typeof v === 'string' && !glSeen[v]) { glm.push(v); glSeen[v] = 1; }
      });
      var curWrongGl = store.readList('tiku-wrong');
      glm = glm.filter(function (v) { return curWrongGl.indexOf(v) < 0; });
      if (glm.length > 200) glm.splice(0, glm.length - 200);
      store.write('tiku-wronggl', glm);
      if (typeof p.combo === 'number' && p.combo > (store.read('tiku-combo', '0') || 0)) { store.write('tiku-combo', p.combo); }
      /* 备考计划：设置时间新者胜；旧 payload 无 plan 字段则跳过 */
      if (p.plan && typeof p.plan.d === 'string' && typeof p.plan.e === 'string') {
        var curPlan = store.read('tiku-plan', 'null');
        if (!curPlan || (p.plan.u || 0) > (curPlan.u || 0)) { store.write('tiku-plan', p.plan); }
      }
      /* 关注考点：按 e|s|k 去重取并集，按关注时间新在前，cap 30；旧 payload 无 kpfav 字段则跳过 */
      var kf = store.readList('tiku-kpfav').filter(function (v) {
        return v && typeof v.e === 'string' && typeof v.s === 'string' && typeof v.k === 'string' && typeof v.n === 'string';
      });
      var kfSeen = {};
      kf.forEach(function (v) { kfSeen[v.e + '|' + v.s + '|' + v.k] = 1; });
      (Array.isArray(p.kpfav) ? p.kpfav : []).forEach(function (v) {
        if (!v || typeof v.e !== 'string' || typeof v.s !== 'string' || typeof v.k !== 'string' || typeof v.n !== 'string') { return; }
        var kk = v.e + '|' + v.s + '|' + v.k;
        if (!kfSeen[kk]) { kf.push({ e: v.e, s: v.s, k: v.k, n: String(v.n).slice(0, 40), ts: v.ts || 0 }); kfSeen[kk] = 1; added += 1; }
      });
      kf.sort(function (x, y) { return (y.ts || 0) - (x.ts || 0); });
      store.write('tiku-kpfav', kf.slice(0, 30));
      /* 最近浏览：按 slug 去重取时间戳较新一条，新在前，cap 30；旧 payload 无 view 字段则跳过 */
      var vw = store.readList('tiku-view').filter(function (v) {
        return v && typeof v.s === 'string' && typeof v.t === 'string' && typeof v.ts === 'number';
      });
      var vwBy = {};
      vw.forEach(function (v) { vwBy[v.s] = v; });
      (Array.isArray(p.view) ? p.view : []).forEach(function (v) {
        if (!v || typeof v.s !== 'string' || typeof v.t !== 'string' || typeof v.ts !== 'number') { return; }
        var curV = vwBy[v.s];
        if (!curV) { vwBy[v.s] = { s: v.s, t: String(v.t).slice(0, 40), ts: v.ts }; added += 1; }
        else if (v.ts > curV.ts) { vwBy[v.s] = { s: v.s, t: String(v.t).slice(0, 40), ts: v.ts }; }
      });
      var vwOut = Object.keys(vwBy).map(function (s2) { return vwBy[s2]; });
      vwOut.sort(function (x, y) { return y.ts - x.ts; });
      store.write('tiku-view', vwOut.slice(0, 30));
      /* AI 答疑：按 slug+问题去重取时间戳较新一条，新在前，cap 30；旧 payload 无 ai 字段则跳过 */
      var ai = store.readList('tiku-ai').filter(function (v) {
        return v && typeof v.s === 'string' && typeof v.q === 'string' && typeof v.a === 'string' && typeof v.ts === 'number';
      });
      var aiBy = {};
      ai.forEach(function (v) { aiBy[v.s + '|' + v.q] = v; });
      (Array.isArray(p.ai) ? p.ai : []).forEach(function (v) {
        if (!v || typeof v.s !== 'string' || !/^[\w-]{1,80}$/.test(v.s) || typeof v.q !== 'string' || !v.q || typeof v.a !== 'string' || !v.a || typeof v.ts !== 'number' || !isFinite(v.ts) || v.ts <= 0) { return; }
        var ak = v.s + '|' + v.q;
        var curA = aiBy[ak];
        if (!curA) { aiBy[ak] = { s: v.s, q: String(v.q).slice(0, 200), a: String(v.a).slice(0, 500), ts: v.ts }; added += 1; }
        else if (v.ts > curA.ts) { aiBy[ak] = { s: v.s, q: String(v.q).slice(0, 200), a: String(v.a).slice(0, 500), ts: v.ts }; }
      });
      var aiOut = Object.keys(aiBy).map(function (k2) { return aiBy[k2]; });
      aiOut.sort(function (x, y) { return y.ts - x.ts; });
      store.write('tiku-ai', aiOut.slice(0, 30));
      /* 纠错记录：按 slug+时间戳 去重取并集，新在前 cap 30；旧 payload 无 fbk 字段则跳过 */
      var fbk = store.readList('tiku-fbk').filter(function (v) {
        return v && typeof v.s === 'string' && typeof v.k === 'string' && typeof v.ts === 'number';
      });
      var fbkBy = {};
      fbk.forEach(function (v) { fbkBy[v.s + '|' + v.ts] = v; });
      (Array.isArray(p.fbk) ? p.fbk : []).forEach(function (v) {
        if (!v || typeof v.s !== 'string' || !/^[\w-]{1,80}$/.test(v.s) || typeof v.k !== 'string' || !Object.prototype.hasOwnProperty.call(FBK_LABEL, v.k) || typeof v.ts !== 'number' || !isFinite(v.ts) || v.ts <= 0) { return; }
        var fk2 = v.s + '|' + v.ts;
        if (!fbkBy[fk2]) {
          fbkBy[fk2] = { s: v.s, k: v.k, d: typeof v.d === 'string' ? v.d.slice(0, 60) : '', ts: v.ts };
          added += 1;
        }
      });
      var fbkOut = Object.keys(fbkBy).map(function (k2) { return fbkBy[k2]; });
      fbkOut.sort(function (x, y) { return y.ts - x.ts; });
      store.write('tiku-fbk', fbkOut.slice(0, 30));
      /* 报告 AI 点评历史：按 卷名+时间戳 去重取并集，新在前 cap 20；旧 payload 无 air 字段则跳过 */
      var air = store.readList('tiku-air').filter(function (v) {
        return v && typeof v.t === 'string' && typeof v.a === 'string' && typeof v.ts === 'number';
      });
      var airBy = {};
      air.forEach(function (v) { airBy[v.t + '|' + v.ts] = v; });
      (Array.isArray(p.air) ? p.air : []).forEach(function (v) {
        if (!v || typeof v.t !== 'string' || !v.t || typeof v.a !== 'string' || !v.a || typeof v.ts !== 'number' || !isFinite(v.ts) || v.ts <= 0) { return; }
        var n2 = (typeof v.n === 'number' && isFinite(v.n) && v.n > 0) ? Math.floor(v.n) : 0;
        var ok2 = (typeof v.ok === 'number' && isFinite(v.ok) && v.ok > 0) ? Math.min(Math.floor(v.ok), n2) : 0;
        var rk2 = v.t + '|' + v.ts;
        if (!airBy[rk2]) {
          airBy[rk2] = { t: String(v.t).slice(0, 60), n: n2, ok: ok2, a: String(v.a).slice(0, 600), ts: v.ts };
          added += 1;
        }
      });
      var airOut = Object.keys(airBy).map(function (k2) { return airBy[k2]; });
      airOut.sort(function (x, y) { return y.ts - x.ts; });
      store.write('tiku-air', airOut.slice(0, 20));
      /* 评论所有权令牌：逐评论 id 取并集，本机已有不覆盖，cap 200（保留 id 较大者）；旧 payload 无 ctok 字段则跳过 */
      var ct = store.read('tiku-ctok', '{}');
      if (!ct || typeof ct !== 'object' || Array.isArray(ct)) ct = {};
      Object.keys((p.ctok && typeof p.ctok === 'object' && !Array.isArray(p.ctok)) ? p.ctok : {}).forEach(function (id) {
        var tv = p.ctok[id];
        if (typeof tv !== 'string' || !tv || tv.length > 64 || !(parseInt(id, 10) > 0)) { return; }
        if (!ct[id]) { ct[id] = tv; added += 1; }
      });
      var ctKs = Object.keys(ct);
      if (ctKs.length > 200) { ctKs.sort(function (a, b) { return a - b; }).slice(0, ctKs.length - 200).forEach(function (k2) { delete ct[k2]; }); }
      store.write('tiku-ctok', ct);
      /* 评论点赞防重：逐评论 id 取并集（须为有限正整数），cap 300 保留 id 较大者；旧 payload 无 clike 字段则跳过 */
      var cl = store.readList('tiku-clike').filter(function (v) { return typeof v === 'number' && isFinite(v) && v > 0 && Math.floor(v) === v; });
      var clSeen = {};
      cl.forEach(function (v) { clSeen[v] = 1; });
      (Array.isArray(p.clike) ? p.clike : []).forEach(function (v) {
        if (typeof v !== 'number' || !isFinite(v) || v <= 0 || Math.floor(v) !== v || clSeen[v]) { return; }
        cl.push(v); clSeen[v] = 1; added += 1;
      });
      if (cl.length > 300) { cl.sort(function (a, b) { return a - b; }); cl = cl.slice(cl.length - 300); }
      store.write('tiku-clike', cl);
      /* 评论举报防重：逐评论 id 取并集（须为有限正整数），cap 300 保留 id 较大者；旧 payload 无 crep 字段则跳过 */
      var cr = store.readList('tiku-crep').filter(function (v) { return typeof v === 'number' && isFinite(v) && v > 0 && Math.floor(v) === v; });
      var crSeen = {};
      cr.forEach(function (v) { crSeen[v] = 1; });
      (Array.isArray(p.crep) ? p.crep : []).forEach(function (v) {
        if (typeof v !== 'number' || !isFinite(v) || v <= 0 || Math.floor(v) !== v || crSeen[v]) { return; }
        cr.push(v); crSeen[v] = 1; added += 1;
      });
      if (cr.length > 300) { cr.sort(function (a, b) { return a - b; }); cr = cr.slice(cr.length - 300); }
      store.write('tiku-crep', cr);
      /* 最近搜索：本机顺序在前，导入未有词追加，非空 ≤40 字符字符串，cap 8；旧 payload 无 kw 字段则跳过 */
      var kws = store.readList('tiku-kw').filter(function (v) { return typeof v === 'string' && v.length > 0; });
      var kwSeen = {};
      kws.forEach(function (v) { kwSeen[v] = 1; });
      (Array.isArray(p.kw) ? p.kw : []).forEach(function (v) {
        if (typeof v !== 'string' || !v || v.length > 40 || kwSeen[v]) { return; }
        kws.push(v); kwSeen[v] = 1; added += 1;
      });
      store.write('tiku-kw', kws.slice(0, 8));
      /* 回复已读基线：逐评论 id 取较大回复数（须为有限非负整数），cap 200 保留 id 较大者；旧 payload 无 cseen 字段则跳过 */
      var cs = store.read('tiku-cseen', '{}');
      if (!cs || typeof cs !== 'object' || Array.isArray(cs)) cs = {};
      Object.keys((p.cseen && typeof p.cseen === 'object' && !Array.isArray(p.cseen)) ? p.cseen : {}).forEach(function (id) {
        var sv = p.cseen[id];
        if (!(parseInt(id, 10) > 0) || typeof sv !== 'number' || !isFinite(sv) || sv < 0 || Math.floor(sv) !== sv) { return; }
        if (sv > (cs[id] || 0)) { cs[id] = sv; added += 1; }
      });
      var csKs = Object.keys(cs);
      if (csKs.length > 200) { csKs.sort(function (a, b) { return a - b; }).slice(0, csKs.length - 200).forEach(function (k2) { delete cs[k2]; }); }
      store.write('tiku-cseen', cs);
      /* 排行榜昵称：本机已设置优先，仅空时采用导入值；旧 payload 无 nick 字段则跳过 */
      if (typeof p.nick === 'string' && p.nick && !store.raw('tiku-nick')) {
        store.writeRaw('tiku-nick', p.nick.slice(0, 20)); added += 1;
      }
      /* 做题偏好：本机已显式设置优先，仅未设置时采用导入值；仅白名单键，值须为 ≤40 字符字符串；旧 payload 无 prefs 字段则跳过 */
      PREF_KEYS.forEach(function (k) {
        var pv = (p.prefs || {})[k];
        if (typeof pv !== 'string' || !pv || pv.length > 40) { return; }
        if (store.raw(k) === null) { store.writeRaw(k, pv); added += 1; }
      });
      /* 我的名次：逐 scoreKey 取时间戳较新一条，cap 40；旧 payload 无 rank 字段则跳过 */
      var rk = store.read('tiku-rank', '{}');
      var rkDirty = false;
      Object.keys(p.rank || {}).forEach(function (k) {
        var rv = (p.rank || {})[k];
        if (!rv || typeof rv.r !== 'number' || typeof rv.p !== 'number') { return; }
        var curR = rk[k];
        if (!curR) { rk[k] = { r: rv.r, p: rv.p, t: rv.t || 0 }; rkDirty = true; added += 1; }
        else if ((rv.t || 0) > (curR.t || 0)) { rk[k] = { r: rv.r, p: rv.p, t: rv.t || 0 }; rkDirty = true; }
      });
      if (rkDirty) {
        var rkKeys = Object.keys(rk);
        if (rkKeys.length > 40) {
          rkKeys.sort(function (a, b) { return (rk[a].t || 0) - (rk[b].t || 0); });
          rkKeys.slice(0, rkKeys.length - 40).forEach(function (k2) { delete rk[k2]; });
        }
        store.write('tiku-rank', rk);
      }
      store.commit();
      return added;
  }

  /* ---------- Zalize 账号云同步（/my/，可选；登录中心站后可把练习记录存云端跨设备合并） ---------- */
  function initZaSync() {
    var panel = document.getElementById('za-panel'); if (!panel) return;
    var hint = document.getElementById('za-hint');
    var actions = document.getElementById('za-actions');
    var msgEl = document.getElementById('za-msg');
    function say(ok, text) {
      msgEl.textContent = text;
      msgEl.className = 'mt-2 text-[13px] ' + (ok ? 'text-emerald-700' : 'text-red-600');
    }
    panel.classList.remove('hidden');
    fetch('/api/za/session').then(function (r) {
      if (!r.ok) { throw new Error('unauth'); }
      return r.json();
    }).then(function (d) {
      if (!d || !d.email) { throw new Error('unauth'); }
      hint.innerHTML = '';
      hint.appendChild(document.createTextNode('已登录 ' + d.email + ' · 数据仍在本机，云端只存你主动上传的一份'));
      actions.style.display = 'flex';
      document.getElementById('za-upload').addEventListener('click', function () {
        say(true, '上传中…');
        fetch('/api/za/sync', { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ payload: dataSnapshot() }) })
          .then(function (r) { if (!r.ok) { throw new Error('http ' + r.status); } say(true, '已上传到云端，另一设备登录后可一键合并'); })
          .catch(function () { say(false, '上传失败，请稍后再试'); });
      });
      document.getElementById('za-pull').addEventListener('click', function () {
        say(true, '拉取中…');
        fetch('/api/za/sync').then(function (r) {
          if (!r.ok) { throw new Error('http ' + r.status); }
          return r.json();
        }).then(function (d2) {
          if (!d2.payload) { throw new Error('empty'); }
          var added = dataMerge(JSON.parse(d2.payload));
          say(true, '已从云端合并：新增 ' + added + ' 条记录，刷新页面查看');
        }).catch(function (e) {
          say(false, e && e.message === 'empty' ? '云端暂无同步数据，请先在有记录的设备上传' : '拉取失败，请稍后再试');
        });
      });
    }).catch(function () {
      hint.innerHTML = '在 <a class="tap-y font-medium text-brand-700 underline underline-offset-2" href="https://account.zalize.com" target="_blank" rel="noreferrer">account.zalize.com</a> 登录 Zalize 统一账号后，可把练习记录存云端跨设备合并（不登录不影响任何功能）';
    });
  }

  /* ---------- 数据备份与迁移（/my/）：本地学习数据导出 JSON / 导入合并，纯本地不上传 ---------- */
  function initDataPort() {
    var exp = document.getElementById('dp-export');
    var imp = document.getElementById('dp-import');
    var msgEl = document.getElementById('dp-msg');
    if (!exp || !imp || !msgEl) return;
    function say(ok, text) {
      msgEl.textContent = text;
      msgEl.className = 'mt-2 text-[13px] ' + (ok ? 'text-emerald-700' : 'text-red-600');
    }
    exp.addEventListener('click', function () {
      var d = new Date();
      var name = 'tiku-data-' + d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0') + '.json';
      var url = URL.createObjectURL(new Blob([dataSnapshot()], { type: 'application/json' }));
      var a = document.createElement('a');
      a.href = url; a.download = name;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 5000);
      say(true, '已导出 ' + name + '，妥善保存后可在任何设备导入合并');
    });
    imp.addEventListener('change', function () {
      var f = imp.files && imp.files[0];
      if (!f) return;
      var rd = new FileReader();
      rd.onload = function () {
        try {
          var p = JSON.parse(String(rd.result));
          if (!p || p.app !== 'tiku-sync') { throw new Error('bad'); }
          var added = dataMerge(p);
          say(true, '已导入合并：新增 ' + added + ' 条记录，刷新页面查看');
        } catch (_) {
          say(false, '文件无法识别：请选择本站导出的 tiku-data JSON 文件，本地数据未改动');
        }
        imp.value = '';
      };
      rd.onerror = function () { say(false, '文件读取失败，请重试'); imp.value = ''; };
      rd.readAsText(f);
    });
  }

  /* ---------- 备考计划（/my/）：tiku-plan={e:考试线,n:名称,d:考期,g:每日题量,s:开始日,u:设置秒}，纯本地 ---------- */
  function initStudyPlan() {
    var card = document.getElementById('plan-card'); if (!card) return;
    var exams;
    try { exams = JSON.parse(card.dataset.planExams || '[]'); } catch (_) { exams = []; }
    if (!Array.isArray(exams)) exams = [];
    var stored = store.read('tiku-plan', 'null');
    var hasPlan = !!(stored && stored.e && stored.d && stored.g > 0 && stored.s);
    if (!exams.length && !hasPlan) return;
    var form = document.getElementById('plan-form');
    var view = document.getElementById('plan-view');
    var done = document.getElementById('plan-done');
    var tools = document.getElementById('plan-tools');
    var sel = document.getElementById('plan-exam');
    var goalSel = document.getElementById('plan-goal');
    card.classList.remove('hidden');
    showNavChip('plan-card');
    function dayDiff(iso) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || ''); if (!m) return null;
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return Math.round((new Date(+m[1], +m[2] - 1, +m[3]) - today) / 86400000);
    }
    function fmt(iso) { return iso.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$2月$3日'); }
    function showForm(plan) {
      sel.innerHTML = '';
      exams.forEach(function (e) {
        var left = dayDiff(e.d);
        if (left === null || left < 0) return;
        var o = document.createElement('option');
        o.value = e.s;
        o.textContent = e.n + (e.t ? ' ' + e.t : '') + ' · ' + fmt(e.d) + '（还有 ' + left + ' 天）';
        sel.appendChild(o);
      });
      if (!sel.options.length) { card.classList.add('hidden'); return; }
      if (plan) { sel.value = plan.e; goalSel.value = String(plan.g); if (sel.selectedIndex < 0) sel.selectedIndex = 0; }
      else {
        var remembered = store.read('tiku-exam', 'null');
        if (typeof remembered === 'string' && remembered) { sel.value = remembered; }
        if (sel.selectedIndex < 0) { sel.selectedIndex = 0; }
        goalSel.value = store.read('tiku-goal', '20') + '';
      }
      if (goalSel.selectedIndex < 0) { goalSel.value = '20'; }
      document.documentElement.classList.remove('ws-plan');
      document.documentElement.classList.remove('ws-planx');
      view.classList.add('hidden'); done.classList.add('hidden'); tools.classList.add('hidden'); tools.classList.remove('flex');
      form.classList.remove('hidden'); form.classList.add('flex');
    }
    /* 计划考期（下计划时的日期）已过：不默默删除，直出「已结束」卡 + 计划期内刷题量 + 下一场；重设/删除由用户决定 */
    function showExpired(plan) {
      var ex = null;
      exams.forEach(function (e) { if (e.s === plan.e) ex = e; });
      var nextLeft = ex ? dayDiff(ex.d) : null;
      var days = store.read('tiku-days', '{}');
      if (!days || typeof days !== 'object') days = {};
      var n = 0;
      Object.keys(days).forEach(function (k) { if (k >= plan.s && k <= plan.d) n += days[k] || 0; });
      document.getElementById('plan-done-head').textContent = plan.n + ' · ' + fmt(plan.d) + ' 已结束';
      document.getElementById('plan-done-sub').textContent = '计划期内共刷 ' + n + ' 题' +
        (ex && nextLeft !== null && nextLeft >= 0
          ? ' · 下一场' + (ex.t ? ' ' + ex.t : '') + ' ' + fmt(ex.d) + '（还有 ' + nextLeft + ' 天）'
          : ' · 下一场考期公布后可重设计划');
      var renew = document.getElementById('plan-renew');
      renew.hidden = !exams.some(function (e) { var l = dayDiff(e.d); return l !== null && l >= 0; });
      renew.textContent = ex && nextLeft !== null && nextLeft >= 0 ? '面向下一场重设计划 →' : '重设备考计划 →';
      card.classList.remove('hidden');
      document.documentElement.classList.remove('ws-plan');
      document.documentElement.classList.add('ws-planx');
      form.classList.add('hidden'); form.classList.remove('flex');
      view.classList.add('hidden'); tools.classList.add('hidden'); tools.classList.remove('flex');
      done.classList.remove('hidden');
    }
    function showView(plan) {
      var ex = null;
      exams.forEach(function (e) { if (e.s === plan.e) ex = e; });
      var ownLeft = dayDiff(plan.d);
      if (ownLeft === null) { try { localStorage.removeItem('tiku-plan'); } catch (_) { /* noop */ } showForm(null); return; }
      if (ownLeft < 0) { showExpired(plan); return; }
      /* 考期未过但服务端已修正日期（官宣）：按服务端显示，下一场接续（ex.d > plan.d 且 plan.d 已过）不会走到这里 */
      var left = ex ? dayDiff(ex.d) : ownLeft;
      if (left === null || left < 0) left = ownLeft;
      document.documentElement.classList.remove('ws-planx');
      document.documentElement.classList.add('ws-plan');
      form.classList.add('hidden'); form.classList.remove('flex');
      done.classList.add('hidden');
      view.classList.remove('hidden');
      tools.classList.remove('hidden'); tools.classList.add('flex');
      var name = (ex ? ex.n : plan.n) || plan.n;
      var date = left === ownLeft ? plan.d : ex.d;
      document.getElementById('plan-head').textContent = name + ' · ' + fmt(date) + (left === 0 ? ' · 今日开考' : ' · 还有 ' + left + ' 天 · 按每日 ' + plan.g + ' 题还可刷约 ' + (left * plan.g) + ' 题');
      /* 自开计划日以来：实际做题（tiku-days 保留窗口内） vs 应完成 已开始天数×每日题量 */
      var days = store.read('tiku-days', '{}');
      var startDiff = dayDiff(plan.s);
      var elapsed = startDiff === null ? 1 : Math.max(1, 1 - startDiff);
      var doneN = 0;
      Object.keys(days).forEach(function (k) { if (k >= plan.s && (days[k] || 0) > 0) doneN += days[k]; });
      var expect = elapsed * plan.g;
      var pct = Math.max(0, Math.min(100, Math.round(doneN / expect * 100)));
      document.getElementById('plan-bar').style.width = pct + '%';
      var pace = document.getElementById('plan-pace');
      var delta = doneN - expect;
      pace.textContent = '开计划 ' + elapsed + ' 天已刷 ' + doneN + ' 题 / 应完成 ' + expect + ' 题 · ' + (delta >= 0 ? (delta === 0 ? '按计划推进' : '超前 ' + delta + ' 题') : '落后 ' + (-delta) + ' 题，今天多刷几题追上');
      pace.classList.remove('text-emerald-700', 'text-amber-700');
      pace.classList.add(delta >= 0 ? 'text-emerald-700' : 'text-amber-700');
      if (delta <= -plan.g && plan.s !== localDay(new Date())) {
        var rec = document.createElement('button');
        rec.type = 'button';
        rec.className = 'ml-2 font-medium text-brand-700 underline hover:no-underline';
        rec.textContent = '重新校准计划';
        rec.addEventListener('click', function () {
          if (!window.confirm('从今天重新起算进度（每日 ' + plan.g + ' 题不变，此前落后不再累计）？')) return;
          plan.s = localDay(new Date());
          plan.u = Math.floor(Date.now() / 1000);
          store.write('tiku-plan', plan);
          showView(plan);
        });
        pace.appendChild(rec);
      }
      var todayN = days[localDay(new Date())] || 0;
      var hit = todayN >= plan.g;
      document.getElementById('plan-today').textContent = '今日作答 ' + todayN + '/' + plan.g + ' 题' + (hit ? ' · 今日任务达成 ✓' : '');
      var hist = store.read('tiku-hist', '[]');
      if (!Array.isArray(hist)) hist = [];
      var dailyDone = dailyDoneToday(hist);
      var quotaHref = planQuotaHref(plan.e, todayN, plan.g, dailyDone);
      /* 达标态主按钮改「再练一组」（与首页 #tg-pl 同字，首帧由 BOOT ws-tghit + .js-pg-* 直出；调整题量后重跑须同步类名） */
      document.documentElement.classList.toggle('ws-tghit', hit);
      var goBtn = document.getElementById('plan-go');
      goBtn.href = hit ? planMoreHref(plan.e) : quotaHref;
      goBtn.textContent = hit ? '再练一组 →' : '去完成今日任务 →';
      /* 今日任务清单：每日一练 / 错题复习 / 刷题量 三件套，逐项完成态 */
      var tasksEl = document.getElementById('plan-tasks');
      if (tasksEl) {
        tasksEl.textContent = '';
        var due = wrongDue();
        var dueSlugs = due.map(toSlug).filter(Boolean).slice(0, 20);
        function task(done, label, href, act) {
          var li = document.createElement('li');
          li.className = 'flex flex-wrap items-center gap-2 text-[13px]';
          var dot = document.createElement('span');
          dot.className = 'inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[11px] font-bold ' +
            (done ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-400');
          dot.textContent = done ? '✓' : '○';
          dot.setAttribute('aria-hidden', 'true');
          var txt = document.createElement('span');
          txt.className = done ? 'text-emerald-700' : 'text-slate-600';
          txt.textContent = label + (done ? '（已完成）' : '');
          li.appendChild(dot); li.appendChild(txt);
          if (!done && href) {
            var a = document.createElement('a');
            a.href = href;
            a.className = 'font-medium text-brand-700 hover:underline';
            a.textContent = act + ' →';
            li.appendChild(a);
          }
          tasksEl.appendChild(li);
        }
        task(dailyDone, '每日一练', '/daily/?exam=' + encodeURIComponent(plan.e), '去做');
        task(due.length === 0, due.length === 0 ? '错题复习 · 无到期错题' : '错题复习 · 待复习 ' + due.length + ' 题',
          dueSlugs.length ? '/practice/?mode=slugs&slugs=' + encodeURIComponent(shuffleSlugs(dueSlugs).join(',')) + '&review=1' : '/my/', '去复习');
        task(todayN >= plan.g, '刷题量 ' + todayN + '/' + plan.g + ' 题', quotaHref, '去刷题');
        task(weeklyMockDone(hist, plan.n), '本周模考（' + curWeekIso() + '）', '/mock/' + encodeURIComponent(plan.e) + '/?paper=w', '去模考');
      }
    }
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var ex = null;
      exams.forEach(function (e) { if (e.s === sel.value) ex = e; });
      if (!ex) return;
      var prev = store.read('tiku-plan', 'null');
      var plan = {
        e: ex.s, n: ex.n, d: ex.d,
        g: Math.max(1, parseInt(goalSel.value, 10) || 20),
        s: (prev && prev.e === ex.s && prev.d === ex.d && prev.s) ? prev.s : localDay(new Date()),
        u: Math.floor(Date.now() / 1000)
      };
      store.write('tiku-plan', plan);
      showView(plan);
    });
    document.getElementById('plan-edit').addEventListener('click', function () { showForm(store.read('tiku-plan', 'null')); });
    function delPlan() {
      try { localStorage.removeItem('tiku-plan'); } catch (_) { /* noop */ }
      showForm(null);
    }
    document.getElementById('plan-del').addEventListener('click', delPlan);
    document.getElementById('plan-done-del').addEventListener('click', delPlan);
    document.getElementById('plan-renew').addEventListener('click', function () { showForm(store.read('tiku-plan', 'null')); });
    if (hasPlan) { showView(stored); } else { showForm(null); }
  }

  return { initMy: initMy, initStudyPlan: initStudyPlan, initZaSync: initZaSync, initDataPort: initDataPort, fillsSettled: fillsSettled };
};
